export default {
  "termsOfUse": "Terms of use",
  "goToHome": "Return to the main page",
  "choose": "Choose",
  "close": "Close",
  "yes": "Yes",
  "no": "No",
  "moreInfo": "More information",
  "send": "Send",
  "sendProcess": "Sending",
  "sendSuccess": "Sent",
  "freeDownload": "Download our mobile application for free",
  "month": "Month",
  "year": "Year",
  "other": "Other",
  "backToStart": "Back to the start",
  "backToOverview": "Back to main menu",
  "or": "or",
  "czechLanguage": "Czech",
  "slovakLanguage": "Slovak",
  "englishLanguage": "English",
  "goNext": "Continue",
  "save": "Save",
  "show": "Show",
  "showAll": "Show all",
  "saveChanges": "Save changes",
  "saveChangesProcess": "Saving",
  "saveChangesSuccess": "Saved",
  "loginText": "Log in",
  "contact": "Contact",
  "done": "Finished",
  "finish": "Finish",
  "skip": "Skip",
  "legalDocuments": "Legal documents",
  "new": "New",
  "free": "Free of charge",
  "until": "by",
  "pilot": "Video call",
  "here": "here",
  "subscribe": "Subscribe",
  "agree": "I agree",
  "disagree": "I disagree",
  "alertInfo": {
    "title": "The uLekára.sk service does not replace the emergency service.",
    "text": "In case of acute problems, call 155.",
    "iAgree": "Got it",
    "errorText": "This field is required."
  },
  "uLekare": {
    "title": "uLékaře.cz"
  },
  "partners": {
    "otherPartners": "Partners"
  },
  "questionForm": {
    "title": "Online Consultation",
    "subtitle": "What's troubling you, for how long, are you taking any medication, have you already been examined, ...",
    "modalTitle": "Attach photos, medical reports or any results.",
    "send": "Send to the doctor",
    "back": "Back to question",
    "sendTitle": "Your question has been sent",
    "next": "Continue",
    "question": {
      "placeholder": "Describe your problem here",
      "errorText": "You must ask the doctor a question, please fill it in."
    },
    "firstName": {
      "title": "First name",
      "placeholder": "Enter the name",
      "helpTextNotShowing": "Your first name",
      "errorText": "First name is required, please, fill it out.",
      "helpTextRealData": "Enter your real name for communication with the healthcare facility."
    },
    "lastName": {
      "title": "Last name",
      "placeholder": "Enter the surname",
      "helpText": "Your surname",
      "errorText": "Last name is required, please, fill it out.",
      "helpTextRealData": "Enter your real surname for communication with the healthcare facility."
    },
    "email": {
      "title": "Email",
      "placeholder": "name@example.cz",
      "helpText": "Our doctors will contact you by email.",
      "hrbHelpText": "We recommend entering a private email.",
      "errorText": "An email address is required, please, fill it out.",
      "errorEmailText": "The email address is in incorrect format.",
      "errorEmailNotExisting": "Please, enter the already existing email address.",
      "invalidBenefitEmail": "Invalid email"
    },
    "phone": {
      "title": "Phone number",
      "placeholder": "123 456 789",
      "helpText": "Our nurses will call you to book medical appointments",
      "errorText": "The phone number is required, please, fill it out.",
      "errorPhoneText": "Enter your phone number ({exampleNumber})."
    },
    "birthYear": {
      "title": "Year of birth",
      "titleRegistered": "Patient´s year of birth",
      "helpText": "Birth year of the person you are asking about.",
      "errorText": "Year of birth is required, please, fill it out.",
      "errorLengthText": "Write the year of birth in a four-digit year format",
      "errorBetweenText": "Write the actual year of birth"
    },
    "zipCode": {
      "title": "ZIP code",
      "helpText": "We will recommend where to schedule your appointment based on your ZIP code.",
      "errorText": "ZIP code is required, please, fill it out.",
      "errorZipCodeText": "ZIP code is in incorrect format."
    },
    "insuranceCompany": {
      "title": "Insurance company",
      "errorText": "It is required to fill in your insurance company",
      "selectInsuranceCompany": "Choose your insurance company"
    },
    "thankYou": {
      "title": "The question has been sent.",
      "perex": "Thank you for submitting your question. You will be notified once it has been answered."
    }
  },
  "fileUpload": {
    "initial": "Click to select files or drag and drop them.",
    "send": "Send",
    "uploadAgain": "Try again, please.",
    "addFiles": "Add photos, medical reports or results.",
    "acceptedTypes": "Allowed types are images (.jpg, .png). Maximum file size is 20 MB, maximum total size of all files is 100 MB.",
    "typeError": "FIle type not supported. Please upload the files in the specified formats .jpg, .png.",
    "sizeError": "Maximum allowed size exceeded. The maximum allowed file size is 20 MB, the maximum allowed size of all files together is 100 MB.",
    "totalSizeError": "The maximum total file size is 100 MB."
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "The company uLékaře.cz",
    "companyList": [
      {
        "title": "Contact"
      },
      {
        "title": "Career",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false"
      },
      {
        "title": "Advertising",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false"
      },
      {
        "title": "Health and prevention in the workplace",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false"
      },
      {
        "title": "Principles of personal data processing",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing"
      },
      {
        "title": "Terms of use",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions"
      },
      {
        "title": "Cookies Policy",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies"
      }
    ],
    "perex": {
      "forCompanies": "At the uLékaře.cz Virtual Hospital, we believe that health is yours. We help people manage their health through technology, a human touch, and medical expertise. Every day, our team of 350+ doctors of all specializations is available to more than 100,000 employees."
    },
    "mottos": [
      "A human touch",
      "Enthusiasm",
      "Expertise",
      "Innovation"
    ]
  },
  "dataProcessing": {
    "iAgree": "I agree to",
    "iAgreeWith": "I agree to",
    "privacyPolicy": "the processing of personal data",
    "privacyPolicyTitle": "Consent to the processing of my personal data, including special categories of personal data.",
    "newsletterProcessing": "receive news and information about discounts from uLékaře.cz.",
    "newsletterText": "I agree with receiving the uLékaře.cz Newsletter (news about the company and uLékaře.cz project or about the products and services of cooperating third parties). You can withdraw your consent by selecting this option in the Newsletter or at the address <a href='mailto:osobniudaje@ulekare.cz'>osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterAgreement": "being sent messages regarding conferences",
    "conferenceNewsletterTitle": "Consent to being sent informational emails (newsletters)",
    "conferenceDataTitle": "I consent to the processing of personal data.",
    "termsConditions": " the Terms of Use",
    "privacyPolicyInAccordance": "We process your data in accordance with the"
  },
  "termsAndConditions": {
    "title": "Terms of use"
  },
  "personalDataProcessing": {
    "title": "Consent to the processing of personal data"
  },
  "newsletter": {
    "title": "Newsletter agreement"
  },
  "error": {
    "universal": "An error occurred",
    "sms": "Current sms delivery time is 5&nbsp;minutes max. Thank you for your patience."
  },
  "errorLayout": {
    "title": "Oops! Something happened.",
    "text": "Sorry, this service is temporarily unavailable. We're working on fixing it. Please try again later.",
    "button": "Back to main page"
  },
  "meta": {
    "partnerNavigation": {
      "title": "Partner navigation"
    },
    "cookies": {
      "title": "Cookie statement"
    },
    "termsAndConditions": {
      "title": "Terms of use"
    },
    "personalDataProcessing": {
      "title": "Principles of personal data processing"
    },
    "emergency": {
      "title": "Emergency",
      "description": "The brief list of acute or life-threatening conditions that we want to alert the patients in order to direct the most urgent cases to emergency care."
    },
    "evaluation": {
      "order": {
        "title": "Doctor visit evaluation",
        "description": "Doctor visit evaluation"
      }
    },
    "mastercard": {
      "title": "Mastercard"
    },
    "sporthelp": {
      "title": "SportHelp"
    },
    "overview": {
      "title": "We offer help, we schedule appointments for you, and we promote health",
      "description": "Ask our medical professionals about your health problems or let us schedule a medical appointment straightaway. We help you to take care of your health. We are online, free and always available."
    },
    "hrbOrderPage": {
      "title": "We schedule you to a doctor",
      "description": "Are you looking for a doctor who examines you? Have you got no idea what doctor should you choose? Leave it up to us. We make appointments to medical professionals all over Czechia. It´s free and always available."
    },
    "hrbQuestionPage": {
      "title": "Ask in our online Consulting Room",
      "description": "Entrust yourself to our doctors, you will receive an answer to any of your questions regarding physical and mental health within 6 hours. Online, free and whenever you need."
    },
    "hrbPreventionPage": {
      "title": "The prevention",
      "description": "We help with prevention. Talk to our doctors about health care issues, get recommendations on prevention and schedule the necessary preventive examinations."
    },
    "login": {
      "title": "Login",
      "description": "Register and have 350 doctors of all specializations within reach. We'll help you schedule a doctor's appointment throughout the Czech Republic. To your health."
    },
    "aeskulab": {
      "title": "My lab results"
    },
    "dashboard": {
      "title": "Health online"
    },
    "dashboardQuestions": {
      "title": "Consultation"
    },
    "dashboardAppointments": {
      "title": "Doctor's appointment"
    },
    "dashboardArticles": {
      "title": "Discover Magazine"
    },
    "dashboardConsultations": {
      "title": "Answered by doctors"
    },
    "dashboardPrevention": {
      "title": "My prevention"
    },
    "dashboardProfile": {
      "title": "My health profile"
    },
    "lostPassword": {
      "title": "Forgot password"
    },
    "passwordReset": {
      "title": "Password reset"
    },
    "emailVerification": {
      "title": "Email verification"
    },
    "registration": {
      "title": "Registration"
    },
    "ePrescription": {
      "title": "How does ePrescription issuance work at uLekára.sk",
      "description": "ePrescription rules..."
    }
  },
  "companies": {
    "menu": {
      "ourService": "Our services",
      "stories": "Reviews",
      "pricing": "Contact us",
      "faq": "FAQ",
      "iWant": "Health for my company"
    },
    "hero": {
      "title": "Health is every company's business",
      "subtitle": "An original employee benefit that makes caring for their health a lot simpler, saving both their and your company’s time.",
      "buttons": {
        "iWant": "Health for my company",
        "ourService": "Our services"
      },
      "items": [
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "We give your employees health advice."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "We arrange a doctor’s appointment, wherever."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "We care for your healthy life - by prevention."
        }
      ]
    },
    "partnersCarousel": {
      "title": "We're trusted by both big and small",
      "subtitle": "+ more than 150 others"
    },
    "companyPresentation": {
      "title": "Our service",
      "benefitList": [
        {
          "icon": "doctor",
          "title": "350+ doctors of all specializations"
        },
        {
          "icon": "rodina",
          "title": "Care for the whole family"
        },
        {
          "icon": "clock",
          "title": "Over 14 years of experience"
        },
        {
          "icon": "phone",
          "title": "A convenient mobile app"
        },
        {
          "icon": "globus",
          "title": "We speak English too"
        }
      ],
      "boxContent": [
        {
          "image": "company_box_2.jpg",
          "text": "A general practitioner for adults or a pediatrician will answer your employee's question."
        },
        {
          "image": "company_box_1.jpg",
          "text": "We offer a second answer by a specialist, whenever needed. We cover all medical fields e.g. dermatology, orthopedics, gynecology, or psychology."
        },
        {
          "image": "company_box_3.jpg",
          "text": "If the doctor recommends the employee should see a doctor, our nurses will take care of everything. The place and date of the appointment are based on the employee's preferences."
        },
        {
          "image": "company_box_4.jpg",
          "text": "Our service includes arranging preventive check-ups and presentations at your company. We'll create materials for your internal communication on the topic of health."
        }
      ],
      "infoBox": {
        "title": "Did you know that...",
        "text": "With our service, your employees can avoid having to see a doctor in about 40 % of cases? Most health-related questions can be answered in their client zone, and we'll take care of everything else."
      }
    },
    "faq": {
      "title": "Frequently asked questions",
      "faqList": [
        {
          "title": "What can the uLékaře.cz Virtual Hospital do for your company?",
          "bodyText": "We know that when companies care for the health of their employees, it pays off. It saves time, reduces absenteeism, and ensures greater employee concentration and performance. With our service, employees can arrange everything quickly from wherever they want, and if they need to see a doctor, we'll make an appointment for a specific place and time.<br/><br/>We can provide employees advice remotely, plus often there's no need to see a doctor or waste time looking for information on the internet. We thus save the employer money that would otherwise be spent on the time an employee isn't working or on someone to do their work in their stead.<br/><br/>Prevention is the best approach, which is why we also provide a comprehensive preventive care programme and Health Days."
        },
        {
          "title": "What can the uLékaře.cz Virtual Hospital do for employees?",
          "bodyText": "The uLékaře.cz service has many benefits for users. After registering, they have access to 350 doctors of all specializations, including pediatricians and GPs, who are prepared to provide quick information regarding any health problem an employee or their family may be dealing with. Our team also has 50 nurses available on the phone to help find a new doctor or specialist where and when they are needed. Employees receive professional and discreet communication with a human touch from the entire medical team, in either Czech or English."
        },
        {
          "title": "How can I order the uLekára.sk service for employees?",
          "bodyText": "If you have less than 100 employees, you can order the service for your company on-line. Our sales department is here for companies with a greater number of employees. We'll be happy to put together a quote for you."
        },
        {
          "title": "Does the service qualify for a tax credit?",
          "bodyText": "Yes, it is a tax-deductible expense under § 24 (1) of the Income Tax Act. According to the General Financial Directorate, it isn't a service provided to employees, but rather a service for the employer who can thus reduce employee absenteeism. This does not involve non-cash income for employees.<br/><br/>We are an on-line medical consultation service that is not a substitute for medical or other professional care. It involves providing advice and offering to find and make appointments with doctors and for examinations. Its goal is to properly direct patients so they receive care from the relevant specialist as soon as possible."
        },
        {
          "title": "How is service security ensured?",
          "bodyText": "Users make use of the uLékaře.cz Virtual Hospital service in their client zone, which is encrypted and therefore all health-related issues can be seen only by themselves and the doctor who is dealing with a given question. At the same time, we meet all the legislative requirements of the EU General Data Protection Regulation (GDPR) 2016/679 and we have obtained ISO/IEC 27001 certification in the field of information security management.<br/><br/>All requests are only dealt with by you and designated individuals on the uLékaře.cz team, or a medical facility of your choice. Even the doctor who is answering you sees, aside from your query, only your first name and age. Other information provided as part of your query can only be accessed by the medical team that is helping make your appointment or to further process your question. Your records are not shared with anyone else."
        },
        {
          "title": "Do employees have to change their GP after registering with the uLékaře.cz Virtual Hospital service?",
          "bodyText": "By registering with our service, you aren't changing your general practitioner. The doctors providing our consultation service will answer every query, and if the employee is interested, we'll make them an appointment with a doctor."
        },
        {
          "title": "Can this benefit shorten the waiting time for examinations, which are usually very long?",
          "bodyText": "Your appointment date always depends on how busy the health care system is. It depends on location and the capacity of local medical care. Often we're able to arrange the required examination more quickly than if you made the appointment yourself. This is because we make appointments with all medical facilities, both public and private, and have a very good overview of doctors' current capacities and waiting times throughout the Czech Republic."
        },
        {
          "title": "Will the employees pay the doctor you are making them an appointment with?",
          "bodyText": "It’s up to you. Our nurses can make appointments with both public and private medical facilities. They always look for the best doctor with respect to your preferred date and availability of doctors in the given specialization. You will be informed of any payment before you visit the doctor."
        },
        {
          "title": "Does the uLekára.sk service arrange ePrescriptions?",
          "bodyText": "If you need an ePrescription, everything takes place as part of the brick-and-mortar care we make appointments for via uLékaře.cz. From the perspective of safe care and proper medication, this is the solution we currently prefer. For us, the most important thing is our clients' health."
        },
        {
          "title": "Can I also arrange the service for a manufacturing company?",
          "bodyText": "Yes, you can. Our service is for all employees regardless of the nature of the business or their job position. Our clients include both banks and manufacturers such as Continental, Unipetrol, Cemex, Metrans, MND, Ideal Standard, Lasvit, and many more."
        },
        {
          "title": "Can the service be offered to only a specific group of employees?",
          "bodyText": "We're proud of the fact that our service is for everyone. Our vision is the availability of our care to all. We know that we're helping everyone regardless of whether they're manual labourers or office workers. That's why we always offer our service only as a benefit for the entire company."
        },
        {
          "title": "How much work do HR personnel have to do on a regular basis in order for the service to be used by employees?",
          "bodyText": "Very little. After purchasing the service, it's important to let employees know that it's available and help them register so it's always at their disposal. We have communication materials available for this purpose that you can use. Once employees register in the client zone, we communicate directly with them."
        },
        {
          "title": "How will I know if my employees are using the service?",
          "bodyText": "From regular reports we'll send you. These include the number of employees registered for the service, the number of times individual services were used, as well as the most frequent specializations or regional use. Everything is of course fully anonymized."
        },
        {
          "title": "How do I pay?",
          "bodyText": "You start paying for the service once you sign the contract. We'll invoice you regularly at agreed-upon intervals."
        },
        {
          "title": "Can I change the services plan?",
          "bodyText": "Yes, you can change your plan at any time by writing <a href=\"mailto:zdravi@ulekare.cz\">zdravi@ulekare.cz</a>. Our corporate team will do what's needed."
        },
        {
          "title": "What if I want to cancel the contract?",
          "bodyText": "The contract is open-ended with a one-month notice period."
        }
      ]
    },
    "stories": [
      {
        "name": "Karolína Kašparová",
        "position": "Head of Operations, Bridgewater",
        "image": "karolina_kasparova.jpeg",
        "perex": "The uLékaře Virtual Hospital lets us consult a doctor regarding health problems in the entire family. The service is available 24 hours a day, can be anonymous, and can quickly connect the employee with the nearest doctor and arrange a personal consultation. Without having to sit around in a waiting room. Thank you."
      },
      {
        "name": "Radka Pučelíková",
        "position": "HR Manager, Aimtec",
        "image": "radka_pucelikova.png",
        "perex": "We introduced the service on 9 October 2018 as a benefit for all 185 employees. We appreciate that it saves time, addresses our employees' health problems (including when they're abroad), can find a specialist, teaches preventive behaviour, and covers their families too. We're glad that young people have also come to appreciate this service too."
      },
      {
        "name": "Scott Marlowe",
        "position": "HR Director, Česká Spořitelna",
        "image": "scott_marlowe.png",
        "perex": "The health of our employees is always an important topic for us. Since April 2020 we've been offering the uLékaře.cz Virtual hospital service to our employees and their families - 24-hour on-line medical consultation and the ability to make a doctor's appointment without the need for an in-person visit and long waiting times. We recommend it!"
      }
    ]
  },
  "conference": {
    "figureAlt": "\"HRajeme dál\" is an activity that helps incorporate caring for one's health and prevention among basic company strategies."
  },
  "emergency": {
    "title1": "When to seek emergency care",
    "perex": "This is a brief list of acute or life-threatening conditions that we want to alert the patients in order to direct the most urgent cases to an emergency care so to avoid delays in medical care by waiting for the doctor´s response in the online counselling. The utmost caution is needed in case of children.",
    "list": [
      {
        "title": "Injuries and bleeding",
        "body": [
          "heavy bleeding or <strong>bright red blood spurting from the wound</strong>",
          "heavy bleeding from the rectum or genital, in women heavy intermenstrual bleeding",
          "open or other obvious fracture",
          "<strong>open wound</strong> in chest or abdomen",
          "<strong>head injuries</strong> with loss of consciousness, behavioral changes, headache, vomiting, pupils of different sizes; speech, vision or movement disorders",
          "<strong>burns in children</strong>, especially on head and hands, genitals or on a larger area of the body of an adult",
          "injuries caused by an <strong>electric shock or lightning</strong>"
        ]
      },
      {
        "title": "Chest pain and chest sensations",
        "body": [
          "chest pain that <strong>persists</strong>, does not respond to common pain medications, escalating pain, crushing or searing pain and chest tightness",
          "<strong>pain that radiates</strong> into the left arm or neck",
          "pain or <strong>arrhythmia accompanied by changes of consciousness</strong>, fainting",
          "if you have similar symptoms repeatedly or you have a heart or circulatory system disease",
          "chest pain with shortness of breath and significant changes of blood pressure"
        ]
      },
      {
        "title": "Shortness of breath",
        "body": [
          "severe breathelessness, feeling <strong>shortness of breath</strong>",
          "<strong>gasping breath</strong> (fish breathing), wheezing or whistling exhale",
          "inability to finish the sentence without taking a breath, necessity to sit or lean on your hands to ease breathing, having to strain the chest muscles to breathe properly",
          "<strong>color changes</strong> of lips, ears or fingers into purple or blue"
        ]
      },
      {
        "title": "Headache",
        "body": [
          "<strong>unbearable, unusual, sudden</strong>, does not respond to medication",
          "wakes up at night or starts immediately after waking up",
          "sudden pain which was preceded by great physical exertion, including sexual activity",
          "pain accompanied by stiff neck, malaise, drowsiness, impaired consciousness, fever",
          "severe or worsening headache in the first following days after head injury, especially with impaired consciousness, vomiting, malaise",
          "accompanied <strong>by visual, speech and movement disorder</strong>"
        ]
      },
      {
        "title": "Abdominal pain and symptoms of indigestion",
        "body": [
          "<strong>severe or colic-like</strong> abdominal pain",
          "<strong>sudden inability to pass stool or gas</strong>, sharp pain",
          "black stool",
          "<strong>vomiting blood</strong>",
          "<strong>a lump on the abdomen</strong>, in the groin, on the testicles, which hurts, it cannot be pushed back (do not try to do it), has a different colour to the surrounding skin"
        ]
      },
      {
        "title": "Fainting, impaired consciousness, spasms",
        "body": [
          "sudden fainting, a fall after which a person does not wake up or behaves abnormally",
          "conditions with <strong>impaired consciousness, speech, vision, limb motility</strong>",
          "<strong>convulsions of a whole body</strong>"
        ]
      },
      {
        "title": "Infections and fevers",
        "body": [
          "conditions accompanied <strong>by fever above 40°C which cannot be reduced by the appropriate dose of medication</strong>",
          "<strong>chills in children, febrile seizure in children</strong>",
          "repeated <strong>uncontrollable vomiting and diarrhea in children</strong>, insufficient fluid intake in children",
          "infections accompanied by general changes in condition/behavior, such as excessive sleepiness, lethargy, inability to eat, drink"
        ]
      },
      {
        "title": "Allergies and swelling",
        "body": [
          "<strong>swelling of the face, neck and inside of the throat, swelling of the tongue</strong>",
          "<strong>shortness of breath</strong>",
          "<strong>difficulty swallowing</strong>",
          "whole-body symptoms such as rush or swelling",
          "unilateral, especially painful swelling of the limb, possibly accompanied by shortness of breath or dry cough"
        ]
      },
      {
        "title": "Dental emergency",
        "body": [
          "toothache with severe headache",
          "toothache with fever",
          "facial swelling on the affected side progressing to neck or accompanied by difficulty swallowing"
        ]
      },
      {
        "title": "Crimes",
        "body": [
          "If you’re being bullied, either physically or mentally, call 112",
          "if you suspect a crime, call 112",
          "should you or your family be in jeopardy due to a crime, call 112"
        ]
      },
      {
        "title": "Psyche",
        "body": [
          "in case of sudden confusion, behavioral changes, uncontrollable aggression, call an ambulance",
          "if you suspect an imminent suicide, call an ambulance"
        ]
      }
    ],
    "title2": "Call 155",
    "title": "When to seek emergency care"
  },
  "emergencyInfo": {
    "titleQuestion": "Before you ask a question",
    "titleonco-prevention": "Before you ask a question",
    "titleOrder": "Before you schedule an appointment",
    "subtitle": "Make sure that you don't have any of the following acute or life-threatening conditions.<br /><a href='{link}' target='_blank' class='black--text link--inline'>When to seek emergency care?</a>",
    "services": "In case of any acute or life-threatening conditions <a href=\"tel:155\" class=\"link--inline black--text\">call 155</a> or seek out emergency medical services immediately.",
    "continueQuestion": "Continue with your question",
    "continueOrder": "Continue with your appointment",
    "dynamicForms": {
      "text": "uLekára.sk is not an emergency medical service. In life-threatening situations, call 155. {emergencyLink}",
      "linkText": "When to seek emergency care"
    }
  },
  "evaluation": {
    "title": "Feedback on the doctor's visit",
    "orderInfo": {
      "zz": "Medical Facility",
      "orderDate": "Date of booking",
      "doctor": "Doctor"
    },
    "error": {
      "title": "You can send the feedback on the doctor's visit only once.",
      "perex": "Thank you, we have already received your feedback."
    },
    "form": {
      "sendTitle": "Thank you for your feedback on the doctor's visit.",
      "title": "Were you satisfied with the doctor's visit?",
      "noVisit": "I did not visit the doctor.",
      "moreInfo": "More information",
      "evaluationError": "Please, send us your feedback.",
      "messageTitle": "Feel free to share with us anything else you would like to say."
    }
  },
  "partnerb2b": {
    "mastercard": {
      "hello": {
        "title": "On-line consultation service and&nbsp;scheduling a doctor’s appointment",
        "perex": "As the holder of a premium or company Mastercard<sup>®</sup> you can make full use of the services provided by uLékaře such as on-line consultation service, schedule an apoinment with doctors throughout the Czech Republic and take better are of your health."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Ask whenever",
            "perex": "A doctor will answer your query within 12 hours.",
            "footer": "Often we're quicker."
          },
          {
            "icon": "calendar/date-31",
            "title": "Schedule an appointment with a doctor",
            "footer": "You can also schedule an appointment without submitting a query."
          }
        ]
      }
    },
    "eon": {
      "howItWorks": {
        "items": [
          {
            "title": "Ask whenever"
          }
        ]
      }
    },
    "sporthelp": {
      "hello": {
        "title": "Online medical consulation service and appointments to a doctor",
        "perex": "SportHelp is a comprehensive service for amateur sportsmen. It focuses primarily on caring for their health. Using the services of the Virtual Hospital uLékaře.cz is part of your SportHelp membership."
      },
      "howItWorks": {
        "items": [
          {
            "title": "Ask whenever"
          }
        ]
      },
      "question": {
        "perex": "One of our doctors will answer your query."
      },
      "faq": {
        "items": [
          {
            "title": "Can I ask about anything?",
            "bodyText": "YES, anything related to physical and mental health."
          },
          {
            "title": "Can you really schedule appointments with all doctors?",
            "bodyText": "YES, the nurses at uLékaře.cz can schedule you an appointment with a&nbsp;general practitioner and all specialists."
          },
          {
            "title": "Do have to switch doctors?",
            "bodyText": "NO, YOU DON’T, you can use our service to merely get an&nbsp;another medical opinion."
          },
          {
            "title": "Will my current doctor find out anything?",
            "bodyText": "NO, we never share your queries with anyone. Everything takes place on-line and solely between you and the doctor from the consultation service who is answering your question."
          },
          {
            "title": "Will I pay anything to use the service?",
            "bodyText": "No, using the uLékaře.cz Virtual Hospital service is part of your SportHelp membership."
          },
          {
            "title": "Will I pay something to the doctor you schedule me with?",
            "bodyText": "Nurses schedule appointments with both public and private healthcare facilities, and look for the best doctor with respect to your preferred date and availability of a&nbsp;doctor in the given specialization. You will be informed of any payments before you visit the&nbsp;doctor."
          },
          {
            "title": "How is confidentiality assured?",
            "bodyText": "Only the doctor answering your question will see the query, your first name, and age. Other information provided as part of your query can only be accessed by the medical team that is helping schedule your appointment or answering your query. Your queries/appointments are not shared with anyone else.<br/><br/> If you are attaching a medical report or other document, we recommend first blacking out visible personal information, and only then uploading it as an attachment to your query in order to maintain absolute anonymity on your end as well."
          },
          {
            "title": "But questions appear on the uLékaře.cz website, will mine be there too?",
            "bodyText": "No."
          },
          {
            "title": "Is using the service secure?",
            "bodyText": "YES, it is. The service complies with the&nbsp;General Data Protection Regulation&nbsp;(GDPR). All requests are only seen by you and designated individuals with the uLékaře.cz Virtual Hospital, or a medical facility you may choose."
          }
        ]
      }
    },
    "philips-sonicare": {
      "howItWorks": {
        "items": [
          {
            "title": "Ask whenever"
          }
        ]
      }
    }
  },
  "masterCard": {
    "faq": "Frequently asked questions",
    "useService": "Use service",
    "menu": {
      "question": "Query",
      "appointment": "Appointment",
      "contact": "Contact"
    },
    "howItWorks": {
      "title": "We're here for you non-stop",
      "items": [
        {
          "icon": "chat",
          "title": "Ask whenever",
          "perex": "A doctor will answer your query within 12 hours.",
          "footer": "Often we're quicker."
        },
        {
          "icon": "calendar/date-31",
          "title": "Schedule an appointment with a doctor",
          "perex": "A nurse will contact you, find a doctor, and schedule you an appointment.",
          "footer": "You can also schedule an appointment without submitting a query."
        }
      ]
    },
    "question": {
      "title": "Consult a doctor",
      "perex": "One of our doctors will answer your query."
    },
    "appointment": {
      "title": "Schedule an appointment with a doctor",
      "perex": "A nurse will contact you, find a doctor, and schedule you an appointment"
    },
    "authorization": {
      "title": "Mastercard<sup>®</sup> authorization",
      "subtitle": {
        "question": "We need to verify the first six digits of your <strong>Mastercard<sup>®</sup> Premium</strong>. No payment is involved, and after verification you will be able to use the services of the uLékaře.cz Virtual Hospital free of charge.",
        "appointment": "We need to verify the first six digits of your <strong>Mastercard<sup>®</sup> Premium</strong>. No payment is involved, and after verification you will be able to use the services of the uLékaře.cz Virtual Hospital free of charge."
      },
      "codeLabel": "Please enter the first 6 numbers from your card",
      "codeError": "The number entered is invalid. Please check that you are entering 6 numbers from your premium or company Mastercard<sup>®</sup>.",
      "sendButton": "Verify"
    }
  },
  "reauthorizationDashboard": {
    "heading": "Your free service will end in {daysLeft} days, on {dayFormat}.",
    "partnerText": "The uLekára.sk service is still paid by {currentPartnerName}.",
    "prolongText": "Extend your uLékaře.cz benefits to keep them free.",
    "prolongFamilyText": "Remind your loved one that you would like to extend the service.",
    "buttonText": "Extend for free",
    "inDay": "day",
    "inDaysLow": "days",
    "inDaysHigh": "days",
    "selfPayNowHeading": "You're a self-payer now. But you don't have to be.",
    "selfPayNowPartnerText": "Who's gonna pay for uLékaře.cz? It could be your employer, insurance company, etc.",
    "selfPayNowProlongText": "Extend your benefits to get the service for free. Just like before.",
    "selfPayNowFamilyPartnerText": "Remind your loved one {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "When they renew their uLekára.sk service, you'll get all your benefits back for free."
  },
  "migraine": {
    "helloImageAlt": "Our specialized consultation service, the Migraine Line, can help you with headaches and other migraine-related symptoms. We'll give you advice on effective treatment options."
  },
  "psoriasis": {
    "helloImageAlt": "Our specialized consultation service, Outsmarting Psoriasis, will help you treat this disorder. We'll give you advice on effective treatment options."
  },
  "hrbPage": {
    "hello": {
      "title": "We're your guide to better health",
      "items": [
        {
          "text": "We're doctors working in every branch of medicine.",
          "icon": "doctor"
        },
        {
          "text": "We're available 24 hours a day, 7 days a week.",
          "icon": "clock"
        },
        {
          "text": "We're here for you and your family.",
          "icon": "rodina"
        }
      ]
    },
    "advisory": "Consultation",
    "order": "Appointment",
    "myHealth": "Prevention",
    "infolines": "Helplines",
    "contact": "Contact",
    "registration": "Sign up",
    "notification": {
      "title": "A health day will take place at your company from November 17-25"
    },
    "hrbArticles": {
      "title": "Prevention",
      "items": [
        {
          "icon": "shield",
          "title": "Prevention does not hurt",
          "perex": "Have your life under control thanks to regular care of your health. Learn what you can about prevention and its possibilities.",
          "linkName": "Find more"
        }
      ]
    },
    "serviceVideo": {
      "title": "We're never closed, and you don't have to knock",
      "videoUrl": "https://www.youtube.com/embed/K1XDGQ9yBno"
    },
    "counseling": {
      "title": "Consultation service",
      "question": "A general practitioner or pediatrician will answer your question within 12 hours.",
      "order": "If our professionals recommend you visit a doctor, wel'll schedule you an appointment.",
      "linkTitle": "Get advice"
    },
    "ordering": {
      "title": "Appointment",
      "perex": [
        "Describe your health problem or tell us what doctor you're looking for.",
        "We'll find a suitable professional in your vicinity.",
        "We'll schedule an appointment at your convenience."
      ],
      "linkTitle": "Schedule"
    },
    "prevention": {
      "title": "Prevention",
      "perex": [
        "Our preventive programmeme helps you avoid illness.",
        "We make sure that both you and your body are happy.",
        "To get started, all we need is a bit of basic information."
      ],
      "linkTitle": "I'm in"
    },
    "faq": {
      "title": "What would you like to know?",
      "faqList": [
        {
          "title": "Can I ask about anything?",
          "bodyText": "YES, anything related to physical and mental health."
        },
        {
          "title": "Can you really schedule appointments with all doctors?",
          "bodyText": "YES, the nurses at uLékaře.cz will book you an appointment with a general practitioner and all specialists."
        },
        {
          "title": "Do I need to switch doctors?",
          "bodyText": "NO, YOU DON’T, you can use our service to merely get a another medical opinion."
        },
        {
          "title": "Will my current doctor find out anything?",
          "bodyText": "NO, we never share your queries with anyone. Everything takes place on-line and solely between you and the consultation service doctor who is answering your question."
        },
        {
          "title": "Will I pay anything to use the service?",
          "bodyText": "NO, you won’t pay anything to use the on-line medical consultation service or scheduling an appointment with a doctor. You can use the service as much as you want as part of your employer’s subscription."
        },
        {
          "title": "Will I pay something to the doctor you schedule me with?",
          "bodyText": "Nurses schedule appointments with both public and private medical facilities, and look for the best doctor with respect to your preferred date and availability of a doctor in the given specialization. You will be informed of any payments before you visit the doctor."
        },
        {
          "title": "How is confidentiality assured?",
          "bodyText": "Only the doctor answering your query will see the question, your first name, and age. Other information provided as part of your query can only be accessed by the medical team that is helping make your appointment or answering your question.<br />Your questions/appointments are not shared with anyone else.<br />If you are attaching a medical report or other document, we recommend first blacking out visible personal information, and only then uploading it as an attachment to your query in order to maintain absolute anonymity on your end as well."
        },
        {
          "title": "But on www.ulekare.cz users’ questions are visible. Will mine be there too?",
          "bodyText": "NO, they won’t. Queries from individuals who have an active service thanks to their employer aren’t published on the website."
        },
        {
          "title": "Is using the service secure?",
          "bodyText": "YES, it is. The service complies with the General Data Protection Regulation (GDPR). All requests are only seen by you and designated individuals with the uLékaře.cz Virtual Hospital, or a medical facility you may choose."
        }
      ]
    },
    "employeeStories": {
      "title": "Stories from our consultation service",
      "stories": [
        {
          "name": "An another medical opinion helped.",
          "perex": "A mother of a 7yo son approached our counselling in hope to confirm a current medical treatment. Her son suffered from a persistent rash that didn´t respond to treatment their dermatologist recommended. He got a prescription for a drug intended for adults, the fact his mother learned in a pharmacy. Based on the photo of the affected place, a doctor in the counselling was able to confirm the current treatment."
        },
        {
          "name": "That was a weight off her mind. ",
          "perex": "To one of our user, her gynaecologist delivered a diagnosis using two abbreviations. Without any further explanation, she was sent to undergo more tests. The woman was immediately full of fear thinking that the abbreviations mean cancer. Doctors from our counselling calmed her down, explaining her diagnosis is so-called \"precancerous\" state. This is quite common and does not automatically mean that she suffers from cancer. More test had to be made to confirm this diagnosis. The woman was grateful, saying \" that was a weight off her mind\"."
        },
        {
          "name": "Straight from our counselling to a medical professional. ",
          "perex": "A young man turned to our counselling with a question concerning a mole on his abdomen. This mole seemed strange to him, and he attached a photo of the mole with approximate size. Specialists in our counselling could not determine its nature solely from a photo. However, it was obvious enough that the mole presents certain asymmetry and uneven edges. Based on an urgent recommendation to undergo an examination at a specialist, our nurse made an appointment at dermatology as soon as possible in his home town."
        }
      ]
    },
    "contactUs": {
      "title": "Client support",
      "subTitle": "Do you need help? Have you got no idea how to fill in a form?"
    },
    "covidLink": {
      "title": "Covid helpline",
      "callUs": "Contact us:",
      "tooltip": {
        "title": "How can we help?",
        "text": [
          "Disease symptoms",
          "Coronavirus and pregnancy",
          "Testing",
          "Preventive and health measures"
        ]
      }
    },
    "asistLink": {
      "title": "SOS psychological help",
      "subtitle": "psychological, legal and financial counselling.",
      "email": "info@e-a.cz",
      "phone": "+420 234 768 710"
    }
  },
  "hrbPageInactive": {
    "title": "We're sorry. The service is no longer available.<br/>If you would like to use the service again, please contact your HR department.",
    "subtitle": "You can use the service uLékaře.cz privately.",
    "getHelp": "Ask the doctor"
  },
  "authorization": {
    "title": "Service activation",
    "subtitle": "To use the service, please enter your corporate email address or the code you have received from your employer. Then follow the instructions.",
    "subtitleEmail": "To start using our services, please provide your work email address and follow the instructions.",
    "subtitleCode": "To start using the service, enter the code you received from your employer. Then follow the instructions.",
    "emailLabel": "Email",
    "codeLabel": "Code",
    "codeHrbError": "Invalid code",
    "codeLengthError": "Incorrect format. The code must contain 2-20 characters",
    "or": "or",
    "contactTitle": "Do you need help?",
    "sendMessage": "The request for using our services has been sent to your work email address <strong class='text-primary'>{email}</strong>, to confirm the request, please follow the link in the email.",
    "changeEmail": "Change email address"
  },
  "checkToken": {
    "generateToken": "Send a new link",
    "expired": {
      "title": "Link expired",
      "perex": "For security reasons links expire after a certain time. Try having another link sent."
    },
    "invalid": {
      "title": "Invalid link",
      "perex": "The link you entered no longer works. It can be because it was already used, or due to a change in conditions."
    },
    "tokenCreated": {
      "title": "The link has been sent.",
      "perex": "We've sent you a new link to your corporate email. Click this link in the email to complete activation."
    }
  },
  "confirmation": {
    "title": "Email verification",
    "subtitle": "Please verify the email address for communication with the uLekára.sk service.<br/>Confirm the link sent to the email address<strong class='text-primary'>{email}</strong>."
  },
  "hrbForm": {
    "title": "Use service uLékaře.cz",
    "problem": {
      "text": "Tell us about your symptoms and how long you've had them.",
      "placeholder": "The more information you give us, the more precise the doctor's answer can be.",
      "errorText": "Please, fill out this field."
    },
    "help": {
      "text": "What would you like to ask our doctors?",
      "placeholder": "Ask the doctor a question.",
      "errorText": "Please, fill out this field."
    },
    "medication": {
      "text": "Provide additional information regarding your health.",
      "placeholder": "For example, what other illnesses you're being treated for, what medications you're taking regularly, whether you have any allergies, and the results of any examinations.",
      "errorText": "Please, fill out this field."
    },
    "order": {
      "question": {
        "text": "What kind of health problems do you deal with? How can we help you?",
        "placeholder": "What kind of doctor do you want to make an appointment to?",
        "errorText": "Please, fill out this field."
      }
    },
    "agreements": {
      "iAgree": "By sending the form you agree to the ",
      "conditions": "Terms and Conditions",
      "service": "of the service uLékaře.cz."
    },
    "thankYou": {
      "question": {
        "title": "Thank you. Your question has been sent.",
        "perex": "We will forward your question to a doctor.<br/> You will receive a response via email.",
        "button": "A new question"
      },
      "appointment": {
        "title": "Thank you. Your order has been accepted.",
        "perex": "Please, wait for a nurse to call.",
        "button": "A new order"
      },
      "prevention": {
        "title": "Your registration in the preventive programme uLékaře.cz has been successful.",
        "content": {
          "start": "We are here to help you with your health by preventing diseases and severe health problems. We do care about the welfare of your body and soul.<br/><br/>In the upcoming months, you will be able to schedule annual exams and tests via the website. Specialized consultation will be also available, you will be able to ask anything about prevention and schedule an appointment.<br/><br/>You can look forward to educational articles and videos as well as a calendar to keep track of your appointments and vaccinations.",
          "thankYou": "Thank you.<br/><br/>Team uLékaře.cz"
        }
      }
    }
  },
  "masterCardFAQ": {
    "title": "Frequently asked questions and answers regarding the uLékaře.cz Virtual Hospital",
    "perex": "Perhaps you have questions related to using on-line medical consulting and scheduling an&nbsp;appointment with a&nbsp;doctor. Here are answers to the most frequent ones.",
    "list": [
      {
        "title": "Can I ask about anything?",
        "bodyText": "YES, anything related to physical and mental health."
      },
      {
        "title": "Can you really schedule appointments with all doctors?",
        "bodyText": "YES, the nurses at uLékaře.cz can schedule you an appointment with a&nbsp;general practitioner and all specialists."
      },
      {
        "title": "Do have to switch doctors?",
        "bodyText": "NO, YOU DON’T, you can use our service to merely get an&nbsp;another medical opinion."
      },
      {
        "title": "Will my current doctor find out anything?",
        "bodyText": "NO, we never share your queries with anyone. Everything takes place on-line and solely between you and the doctor from the consultation service who is answering your question."
      },
      {
        "title": "Will I pay anything to use the service?",
        "bodyText": "NO, you won’t pay anything to use the on-line medical consultation service or to schedule an appointment with a doctor. You can use the service for free if you have a premium or company Mastercard<sup>®</sup>.<br/><br/><strong>Premium cards:</strong><ul><li>Mastercard<sup>®</sup> Gold</li><li>Mastercard<sup>®</sup> Platinum</li><li>Mastercard<sup>®</sup> World</li><li>Mastercard<sup>®</sup> World Elite</li></ul><strong>Company cards:</strong><ul><li>Mastercard<sup>®</sup> Business</li><li>Mastercard<sup>®</sup> Corporate</li></ul>"
      },
      {
        "title": "Will I pay something to the doctor you schedule me with?",
        "bodyText": "Nurses schedule appointments with both public and private healthcare facilities, and look for the best doctor with respect to your preferred date and availability of a&nbsp;doctor in the given specialization. You will be informed of any payments before you visit the&nbsp;doctor."
      },
      {
        "title": "How is confidentiality assured?",
        "bodyText": "Only the doctor answering your question will see the query, your first name, and age. Other information provided as part of your query can only be accessed by the medical team that is helping schedule your appointment or answering your query. Your queries/appointments are not shared with anyone else.<br/><br/> If you are attaching a medical report or other document, we recommend first blacking out visible personal information, and only then uploading it as an attachment to your query in order to maintain absolute anonymity on your end as well."
      },
      {
        "title": "But questions appear on the uLékaře.cz website, will mine be there too?",
        "bodyText": "NO, THEY WON'T, questions from premium or company Mastercard<sup>®</sup> holders are not published on the site."
      },
      {
        "title": "Is using the service secure?",
        "bodyText": "YES, it is. The service complies with the&nbsp;General Data Protection Regulation&nbsp;(GDPR). All requests are only seen by you and designated individuals with the uLékaře.cz Virtual Hospital, or a medical facility you may choose."
      }
    ]
  },
  "preventionForm": {
    "title": "Tell us more about yourself",
    "subtitle": "If our doctors decide that your health problem requires you to see a doctor, we need more information in order to schedule you an appointment.",
    "birthDate": {
      "title": "Date of birth",
      "helpText": "Please enter your date of birth in the format dd,mm,yy, e.g. 21.1.1991",
      "errorText": "Please enter your date of birth.",
      "errorTextDate": "The date of birth format is incorrect.",
      "errorTextBirthDateRange": "Please enter the correct date of birth."
    },
    "gender": {
      "title": "Sex",
      "selectGender": "Select gender",
      "errorText": "Gender is required, please select.",
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "language": {
      "title": "Language",
      "selectLanguage": "Select the language for communication",
      "errorText": "The language for communication is required, please select."
    },
    "preventiveCheckUp": {
      "title": "Annual medical exams and vaccinations",
      "examinationTitle": "Please, choose the <strong>medical exams</strong> you have undergone (optional):",
      "examinationDate": "When did you undergo the exam the last time?",
      "vaccinationDate": "When was the last time you got vaccinated?",
      "examinationsSubtitle": "Were these tests included in the last exam?",
      "vaccinationTitle": "Please, choose <strong>vaccinations</strong> you have undergone so far (optional):",
      "nameExamination": "The name of the examination",
      "examinationSelectBtn": "Choose medical exams from the list",
      "vaccinationSelectBtn": "Choose a vaccination from the list.",
      "dateRange": {
        "range_1": "This year",
        "range_2": "Last year",
        "range_3": "The year before last ",
        "range_4": "I do not remember",
        "range_5": "Never"
      },
      "otherTitle": "The name of the medical examination",
      "selectYear": "Select year",
      "iAmNotSure": "I do not remember"
    },
    "address": {
      "title": "Address (optional)",
      "placeholder": "Share your location"
    },
    "registeredModal": {
      "title": "Thank you",
      "subtitle": "You have already registered for the prevention programme."
    }
  },
  "ulekareContacts": {
    "email": "info@ulekare.cz",
    "phone": "+420&nbsp;227&nbsp;072&nbsp;720",
    "hours": "Mon-Fri 8:00&nbsp;AM&nbsp;-&nbsp;5:00&nbsp;PM"
  },
  "authorizationPage": {
    "title": "Authorization successful",
    "successText": "We've successfully verified that you're entitled to the free service.",
    "prevention": {
      "title": "Thank you. The authorization was successful.",
      "subtitle": "Confirm the link sent to the email <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "verification": {
    "title": "Login to the prevention programme was successful.",
    "subtitle": "Thank you for the email verification."
  },
  "errorModal": {
    "title": "Hmm, this page isn’t feeling well right now",
    "subtitle": "<p>Looks like we’re having a technical issue on our side.</p>\n\n<p><strong>What you can try:</strong></p>\n<ul>\n  <li>Refresh the page using Ctrl + F5 (Windows) or Cmd + Shift + R (macOS).</li>\n  <li>Log out and log back in.</li>\n</ul>\n<br/>\n<p>Still not working? Open the page in a private (incognito) window.</p>",
    "errorCodeReference": "Please mention the following error code in your communication:"
  },
  "renewPassword": {
    "title": "Password reset",
    "subtitle": "Create a new password for your account. We recommend creating a stronger password that contains at least one number and one letter.",
    "setPassword": "Enter password",
    "setPasswordAgain": "Enter your password again.",
    "newPassword": "New password",
    "changePassword": "Change Password",
    "minLengthError": "Password must contain at least 5 characters.",
    "requiredErrorText": "Password is required",
    "generatedError": {
      "start": "Password must",
      "minLength": "be minimum {length} characters length",
      "and": "and",
      "require": "contain",
      "oneChar": "letter",
      "oneNumber": "number",
      "specialChar": "special character"
    },
    "sameAsPasswordErrorText": "Passwords do not match.",
    "successMessage": "Password has been successfully changed.",
    "invalidToken": {
      "title": "The link is not valid.",
      "perex": "Please, generate a new link by clicking on \"forgotten password\" in the uLékaře.cz mobile app."
    },
    "usedToken": {
      "perex": "This link is no longer valid because it has already been used."
    },
    "expiredToken": {
      "title": "Unfortunately, the link has expired.",
      "perex": "Please, generate a new link by clicking on \"forgotten password\" in the uLékaře.cz mobile app."
    },
    "nextButton": "Log in to {service}"
  },
  "emailVerification": {
    "successMessage": "Email verified",
    "successMessagePerex": "We've successfully verified your email address. You can log in.",
    "button": "Continue on {service}",
    "invalidToken": "The link is not valid.",
    "usedToken": "This link is no longer valid because it has already been used.",
    "expiredToken": "Unfortunately, the link has expired."
  },
  "partnerNavigation": {
    "hello": {
      "title": "How you can start using the uLékaře.cz Virtual Hospital service.",
      "items": [
        {
          "icon": "compass",
          "text": "Log in or create an account."
        },
        {
          "icon": "glasses",
          "text": "You can then start using our service."
        }
      ]
    },
    "helloHrb": {
      "title": "Use the uLekára.sk service.",
      "items": [
        {
          "icon": "compass",
          "text": "Find your employer by the company name."
        },
        {
          "icon": "glasses",
          "text": "Select the service you want to use."
        }
      ]
    },
    "partnerSignpost": {
      "title": "Do you have a free service?",
      "subtitle": "Who pays for the service?"
    },
    "tabs": [
      "Different benefit",
      "Mastercard<sup>®</sup>"
    ],
    "employer": {
      "title": "Find your employer by name.",
      "searchPlaceholder": "Enter your company name"
    },
    "results": {
      "noResultStart": "Can't find your employer?",
      "noResultContact": "Contact us",
      "noResultMiddle": "or",
      "noResultReadMore": "read more",
      "noResultEnd": "about the service."
    },
    "partnerTypes": [
      {
        "boxTitle": "The service is from my employer"
      },
      {
        "buttonText": "Choose",
        "title": "Click on your insurance company's logo.",
        "boxTitle": "The service is from my insurance company",
        "partnerGtmAction": "Click Go to insurance company",
        "boxes": [
          {
            "gtmLabel": "VoZP",
            "isExternalLink": "true",
            "image": "partner-vozp.png",
            "link": "kp.vozp.cz"
          },
          {
            "gtmLabel": "OZP",
            "isExternalLink": "true",
            "image": "partner-ozp.png",
            "link": "www.ozp.cz/vkol"
          }
        ]
      },
      {
        "buttonText": "Go to the service",
        "title": "Click on the logo to use the uLékaře.cz Virtual Hospital service.",
        "boxTitle": "The service is from Mastercard",
        "partnerGtmAction": "Click Mastercard box",
        "boxes": [
          {
            "gtmLabel": "Mastercard",
            "isExternalLink": "false",
            "image": "logos/mc_logo.png",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "mastercard"
              }
            }
          }
        ]
      },
      {
        "buttonText": "Choose",
        "title": "Click on your partner's logo.",
        "boxTitle": "The service is a benefit",
        "partnerGtmAction": "Click go to partner",
        "boxes": [
          {
            "gtmLabel": "Fairsurence",
            "image": "partner-fairsurence.png",
            "isExternalLink": "false",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "spolekpromaterstvi"
              }
            }
          }
        ]
      }
    ],
    "video": {
      "title": "We’re never closed, and you don’t have to knock."
    }
  },
  "unsupportedBrowser": {
    "title": "Your browser isn’t supported",
    "perex": "We’re sorry, but you’re using an older web browser that doesn’t fully support our service. To be able to make full use of the service, please use one of the following supported browsers or perform an update."
  },
  "login": {
    "banner": {
      "title": "Your data will remain secure.",
      "subtitle": "We are constantly improving our services so that your information remains only yours. That's our priority."
    },
    "socials": {
      "facebook": "Log in via Facebook",
      "google": "Log in via Google",
      "apple": "Log in via Apple"
    },
    "title": "Log in",
    "subtitle": "To use uLekára.sk services, please log in",
    "loginError": "Invalid login data. Please try again.",
    "forgetPassword": "Forgotten password?",
    "password": {
      "title": "Password",
      "requiredError": "Password is required"
    },
    "remember": "Remember user",
    "login": "Log in",
    "noAccount": "Don't have an account yet?",
    "registration": "Sign up.",
    "registrationHeaderButton": "Sign up"
  },
  "registration": {
    "title": "Sign up",
    "subtitleFirstStep": "You need to sign up to use the services of the uLékaře.cz Virtual Hospital",
    "subtitle": "Your details will be used for communication with our medical team",
    "addData": {
      "title": "Complete the information",
      "subtitle": "Your log in is successful but we need to update the information used for communication with uLékaře.cz medical team"
    },
    "emailError": "Your email is on uLékaře.cz already registered.",
    "email": {
      "errorEmailNotExisting": "Enter existing email address.",
      "errorInvalidDomain": "Used email domain is not allowed due to a frequent abuse. Try another email or create a new one.",
      "errorText": "Missing email.",
      "title": "Personal email"
    },
    "socials": {
      "facebook": "Sign up via Facebook",
      "google": "Sign up via Google",
      "apple": "Sign up via Apple"
    },
    "loginText": {
      "link": "Log in",
      "suffix": ", please",
      "question": "This email address has already been used to sign up."
    },
    "login": {
      "text": "Already have an account?",
      "link": "Log in."
    },
    "finishRegistration": "Complete sign up",
    "legal": {
      "text": "I agree with the {termsAndConds}.",
      "termsConditions": "Terms of Use",
      "privacyPolicy": "Principles of Personal Data Protection."
    }
  },
  "missingProfileData": {
    "title": "Complete your personal information",
    "titleLegal": "Consent confirmation",
    "text": "We could not retrieve your email address from the connected account. It is essential for the provision of our services. Please, fill it in below.",
    "textLegal": "Please confirm the following:"
  },
  "phoneVerification": {
    "title": "Phone number verification",
    "subtitle": "We have just sent a verification code to your phone number {phone}. Please enter it below.",
    "label": "SMS code",
    "changeNumber": "Change number",
    "inputError": "Code is mandatory",
    "codeError": "The code you entered is invalid. Do you need help? Contact us.",
    "sendAgain": "Send code again",
    "verify": "Verify",
    "error": {
      "error_timeout": {
        "title": "Please wait for the SMS verification code",
        "perex": "We recorded repeated phone number change requests. Please wait to avoid excess of incoming SMS messages."
      },
      "error_block": {
        "title": "Account temporarily suspended",
        "perex": "Phone number validation was canceled due to suspicious activity. The temporary suspension of your account is a safety precaution. Please, get in touch with our customer service",
        "callUs": "Speak to us",
        "writeUs": "Write us an email"
      }
    }
  },
  "phoneChange": {
    "title": "Change of phone number",
    "sendCode": "Send code"
  },
  "lostPassword": {
    "title": "Forgotten password",
    "subtitle": "Password reset link will be received when you registered using this email on our website or in the mobile app.",
    "button": "Reset password",
    "linkSentTitle": "Link sent",
    "linkSentPerex": "A password reset link has been sent to {email}. If you don't find it in your inbox, check the spam folder.",
    "sendLinkAgain": "Send link again",
    "finishRegistration": "Complete sign up"
  },
  "profileSection": {
    "menu": {
      "profile": "My account",
      "subscription": "Subscription",
      "logout": "Logout"
    },
    "badge": {
      "self": "self-pay",
      "premium": "covered"
    },
    "freeService": {
      "title": "Free service",
      "text": "Our service is often covered by partners, employers and insurance companies.",
      "button": "Am I eligible?"
    },
    "thankYou": "Service is covered by {partnerName}",
    "thankYouSelf": "You self-pay for our service",
    "thankYouHost": "Free service is shared by {host}"
  },
  "dashboard": {
    "menu": {
      "home": "Home",
      "questions": "Consultations",
      "appointments": "Appointments",
      "prevention": "Prevention",
      "explore": "Discover"
    },
    "personalInfoAssurance": {
      "prefix": "How should we communicate with you?",
      "email": "Email",
      "phone": "Phone"
    },
    "deactivatedUser": "<strong>Your account was deactivated.</strong> If you think this should not have happened, please write us at <a href=\"mailto:{email}\">{email}</a> or call us at {phone}.",
    "title": "Hello! 👋",
    "subtitle": "How can we help you?",
    "needAdvice": "Write a question",
    "needAppointment": "Schedule appointment",
    "needHelp": "Do you need advice?",
    "supportBox": {
      "openTitle": "Support",
      "title": "Customer support",
      "boxText": "We are here for you, whatever you need help with",
      "chat": {
        "title": "Customer chat",
        "textOnline": "We are online <br /> Whatever non-medical question or problem you have. We are here for you.",
        "textOffline": "We are offline <br /> We are online 8:00 - 17:00 (Mon-Fri)",
        "button": "Start chat",
        "icon": "chat"
      },
      "customerService": {
        "title": "Customer line",
        "subtitle": "8:00 - 17:00 (Mon-Fri)",
        "buttonEmail": {
          "text": "info@ulekare.cz",
          "subtitle": "Contact e-mail:"
        },
        "buttonPhone": {
          "text": "+420 227 072 720",
          "subtitle": "Toll line:"
        },
        "linkEmail": "mailto:info@ulekare.cz",
        "linkPhone": "tel:+420 227 072 720",
        "icon": "care",
        "tescoButtonPhone": {
          "text": "+420 800 100 211",
          "subtitle": "Toll-free line:"
        },
        "tescoLinkPhone": "tel:+420 800 100 211",
        "tescoButtonPhonePaid": "Toll-free line +420 227 072 720",
        "tescoLinkPhonePaid": "tel:+420 227 072 720"
      },
      "assistanceService": {
        "title": "SOS psychological help",
        "subtitle": "Psychological counselling",
        "buttonEmail": "info@e-a.cz",
        "buttonPhone": "+420 234 768 710",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+420 234 768 710",
        "icon": "happy"
      },
      "covidService": {
        "title": "Covid infoline",
        "button": "+420 226 284 227",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+420 226 284 227",
        "icon": "lungs"
      },
      "unavailableOn": "Please note that customer support and service of scheduling appointments will be available on a limited basis on {date}. Requests submitted may be processed with a delay. For general information, please email us at the address provided. \nThank you for your understanding.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Free service?",
    "requestSent": "Finish activation in the work email",
    "hint": {
      "subtitle": "surgeon, co-founder of the uLékaře.cz Virtual Hospital",
      "text": "\"Quickly arrange everything from the comfort of your home or from work. If you need to see a doctor in person, we'll help you schedule an appointment.<br/>Do you need advice? I or one of my 350 colleagues will be glad to help you.\""
    },
    "questions": {
      "myQuestions": "My questions",
      "updated": "We have an answer for you!",
      "resolvers": "Caring for you",
      "sla": "We'll answer by <strong class='black--text'>{hour}</strong>."
    },
    "appointments": {
      "myAppointments": "My appointments"
    },
    "labTests": {
      "draft": "Pick a place, date and time to provide your sample",
      "new": "Your samples are being analyzed by the laboratory",
      "done": "We have the interpretation of your blood tests!"
    },
    "videoCall": {
      "buttonText": "Schedule video call",
      "buttonTextMobile": "Video call"
    },
    "services": {
      "question": {
        "title": "Consultation 24/7",
        "subtitle": "with answer within {hours}h",
        "text": "Our doctors are here for you. All in one place. Any time.",
        "button": "Get advice"
      },
      "videoCall": {
        "title": "Video call",
        "subtitle": "with doctor",
        "text": "Consult our doctor on a video call (for up to 20 minutes) at a time of your choice.",
        "button": "Schedule video call"
      },
      "appointment": {
        "title": "Appointment",
        "subtitle": "throughout Slovakia",
        "text": "Our nurses will help you find the right doctor for all your needs.",
        "button": "Schedule appointment"
      },
      "prevention": {
        "title": "Prevention",
        "subtitle": "health in your hands",
        "text": "Supporting you in taking the optimum care of your health.",
        "existedButton": "Enter prevention"
      },
      "thematic_counseling": {
        "title": "Topic-based consultations",
        "text": "You can make use of our consultation services focused on a specific topic. Ask our experts about things that interest you.",
        "button": "Browse topics"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Service is not available in {language}. To use the service change the language in <a href=\"{link}\" class=\"link--inline\">your profile</a>.",
          "cs": "Czech",
          "en": "English",
          "sk": "Slovak"
        }
      },
      "labTest": {
        "title": "Lab tests",
        "subtitle": "health in your hands",
        "text": "With our help, take the best possible care of your health.",
        "button": "Fill in the questionnaire"
      },
      "videoTherapy": {
        "subtitle": "with a therapist",
        "title": "Video call",
        "text": "Have a discreet on-line talk. You’ll have 50 minutes to speak with a professional.",
        "button": "Pick a date and time for the video call",
        "textUnavailable": "The number of therapies has been exhausted. Contact your HR department for more information."
      }
    },
    "news": "New features",
    "recomended": "Recommended for you",
    "emailVerification": {
      "title": "Email address verification",
      "subtitle": "Check your inbox <strong>{email}</strong> and use the verification link in the email we have just sent you.",
      "text": [
        {
          "title": "Can't find the e-mail?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Check your spam folder"
            },
            {
              "icon": "check_circle",
              "text": "Wait a few minutes and resend the e-mail"
            }
          ]
        },
        {
          "title": "Did you enter the wrong email?",
          "text": "Please start the sign up again"
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Send email again"
        }
      }
    },
    "help": {
      "text": "Need help?",
      "hours": "Mon-Fri 8 a.m. - 5 p.m."
    }
  },
  "videoCall": {
    "infoStep": {
      "title": "Online session with a doctor",
      "perex": "When a few lines of text are not enough, talk to our doctor on video. Discuss any health problem without stepping into the doctor's office.",
      "list": {
        "first": "Make sure you have filled in your contact information and verified your phone number.",
        "second": "Pick the date and time that suits you. You can even squeeze one into a lunch break.",
        "third": "At the scheduled time, join the video session. The doctor will devote 20 minutes only to you."
      },
      "legal": [
        "We are brokering you a service from the following healthcare services provider:",
        "uLékaře.cz Health Care,&nbsp;s.r.o.<br/>with registered offices at&nbsp;Českomoravská 2408/1a, 190&nbsp;00&nbsp;Prague&nbsp;9 ID:&nbsp;096&nbsp;64&nbsp;777<br/>maintained&nbsp;at&nbsp;the&nbsp;Prague&nbsp;Municipal&nbsp;Court, file No&nbsp;C&nbsp;339989",
        "The&nbsp;\"Video call with&nbsp;a&nbsp;doctor\" healthcare service is&nbsp;not&nbsp;covered by public health insurance. It will be paid&nbsp;for&nbsp;by&nbsp;your employer.",
        "The&nbsp;\"Video call with&nbsp;a&nbsp;doctor\" service is a healthcare service provided remotely as&nbsp;a&nbsp;videoconference with a&nbsp;doctor, and&nbsp;only&nbsp;in the&nbsp;field&nbsp;of&nbsp;internal medicine."
      ],
      "button": "Pick video call slot"
    },
    "formStep": {
      "title": "Check your information",
      "legal": {
        "termsConditions": {
          "text": "I agree with the {legalText} of a Videoconference with a doctor from the healthcare services provider uLékaře.cz Health Care, s.r.o.",
          "legalText": "Terms and Conditions of the service"
        },
        "personalData": {
          "text": "We process your data in accordance with the {link}.",
          "legalText": "Principles of Personal Data Processing"
        }
      }
    },
    "iframeStep": {
      "title": "Choose a time slot"
    }
  },
  "tally": {
    "anxiety": {
      "infoStep": {
        "button": "Fill in the questionnaire"
      },
      "urls": {
        "b2b": ""
      }
    },
    "wellbeing": {
      "dashboardBox": {
        "title": "Well-being test",
        "text": "How are you, really? Test your well-being."
      },
      "infoStep": {
        "title": "How are you doing?",
        "timeApproximation": "~2 minutes",
        "perex": "Well-being is a term that covers overall physical, mental, and emotional health. Well-being is affected by your health, relationships, and other aspects.",
        "list": [
          "Answer five short questions.",
          "You get your results immediately, along with tips to help you feel better."
        ],
        "garant": {
          "title": "Test guarantor",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychology",
          "workplace": "Psychologist from uLékaře.cz"
        },
        "button": "Fill in the questionnaire"
      }
    },
    "insomnia": {
      "dashboardBox": {
        "title": "Insomnia test",
        "text": "How are you sleeping? Take our test."
      },
      "infoStep": {
        "title": "How's your sleep?",
        "timeApproximation": "~2 minutes",
        "perex": "Having trouble falling asleep lately? Or do you wake up during the night? Long-term insomnia can influence well-being and health.",
        "list": [
          "Spend 2 minutes answering eight short questions.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Michaela Štěpánová, MSc.",
          "specialization": "Psychology",
          "workplace": "Psychologist from Soulody.hu"
        },
        "button": "Complete survey"
      },
      "urls": {
        "b2b": "https://tally.so/r/nGWrLo"
      }
    },
    "alcohol": {
      "infoStep": {
        "button": ""
      }
    },
    "depression": {
      "dashboardBox": {
        "title": "Depression risk test",
        "text": "Is it a bad mood, or depression? Take a test.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Bad mood, or depression?",
        "timeApproximation": "~2 minutes",
        "perex": "Have you felt exhausted recently, without energy, and nothing makes you happy? This on-line depression risk test can help you identify your feelings.",
        "list": [
          "Pick the answers that best match your current situation.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponzor",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychology",
          "workplace": "Psychologist from uLékaře.cz"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/wdrYlA",
        "b2c": ""
      }
    },
    "liver": {
      "dashboardBox": {
        "title": "Healthy liver test",
        "text": "Take this test to see how well you’re caring for your liver.",
        "button": "Take the test"
      },
      "infoStep": {
        "title": "Are you taking proper care of your liver?",
        "timeApproximation": "~3 minutes",
        "perex": "This short test will tell you how your liver is doing and if it needs better care than it’s had till now.",
        "list": [
          "Pick the answers that you consider correct and match your health.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Maj. Dr. Denisa Gottvaldová from uLékaře.cz",
          "specialization": "General medicine for adults",
          "workplace": "Bechyně Medical Services Centre"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/mKbM07"
      }
    },
    "heart": {
      "dashboardBox": {
        "title": "Do you have a healthy heart?",
        "text": "A few questions will tell you what your heart wants.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "How is your heart doing?",
        "timeApproximation": "~3 minutes",
        "perex": "This test will tell you whether our heart is healthy or if it’s already sounding the alarm.",
        "list": [
          "Spend 3 minutes answering ten short questions.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Dr. Oleksii Bolotskykh",
          "specialization": "Adult cardiologist",
          "workplace": "Kardiologie na Bulovce, s.r.o."
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/3q6bP7"
      }
    },
    "adhd": {
      "urls": {
        "b2b": "https://tally.so/r/mRpzLJ"
      },
      "infoStep": {
        "button": "Complete the form",
        "garant": {
          "workplace": "Psychological Services Centre, Ostrava",
          "specialization": "psychologist, psychotherapist",
          "name": "PhDr. Sylvie Navarová",
          "title": "Test sponsor"
        },
        "list": [
          "Answer 10 questions. Don’t take too long, choose the first thing that pops into your head.",
          "At the end of the test you’ll get useful self-help information."
        ],
        "perex": "Are your thoughts like bees or do you concentrate like a chess player? This short test will tell you more.",
        "timeApproximation": "~3 minutes",
        "title": "How’s your concentration?"
      },
      "dashboardBox": {
        "button": "Complete the test",
        "text": "Test your attention and ability to concentrate.",
        "title": "How’s your concentration?"
      }
    },
    "imunity": {
      "dashboardBox": {
        "title": "Immunity test",
        "button": "Complete the test"
      },
      "infoStep": {
        "title": "Do you have a strong immune system?",
        "timeApproximation": "~2 minutes",
        "perex": "Take a test that will tell you whether your immune system works like a shield or if it is defeated by every illness.",
        "list": [
          "Spend two minutes answering eight short questions.",
          "As soon as you’re done you’ll see your results, including practical tips."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Jana Emlerová",
          "specialization": "Allergy and clinical immunology specialist",
          "workplace": "GENNET Allergy and Clinical Immunology"
        },
        "button": "Complete the test"
      },
      "urls": {
        "b2b": "https://tally.so/r/npaLVb",
        "b2c": ""
      }
    },
    "circulation": {
      "dashboardBox": {
        "title": "Vessel Health Check",
        "text": "A few questions will reveal how your circulatory system is doing.",
        "button": "Complete the test"
      },
      "infoStep": {
        "title": "How can you improve your blood circulation?",
        "timeApproximation": "~2 minutes",
        "perex": "Find out whether your heart and blood vessels are working optimally or if they need a bit of help.",
        "list": [
          "Answer 10 short questions.",
          "You’ll immediately see your results plus handy tips on how to improve your blood circulation."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Markéta Hadrabová",
          "specialization": "General practitioner and haematologist",
          "workplace": ""
        },
        "button": "Complete the test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wzlj80"
      }
    },
    "flexibility": {
      "dashboardBox": {
        "title": "Do you have a flexible body?",
        "text": "Test your flexibility with ten questions.",
        "button": "Complete the test"
      },
      "infoStep": {
        "title": "How flexible is your body?",
        "timeApproximation": "~2 minutes",
        "perex": "Find out whether your body is like a spring or more like a stiff board.",
        "list": [
          "Answer 10 short questions.",
          "Read your results and discover tips for better flexibility."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MgA. Klára Lidová, Ph.D.",
          "specialization": "Fascia specialist, expert in dance and sports medicine",
          "workplace": "YOTAI private practice, National Theatre in Prague"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/3E4RW2"
      }
    },
    "digitalhealth": {
      "dashboardBox": {
        "title": "Digital Health Test",
        "text": "Find out if the digital world is your servant or your master.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Do you control technology, or does it control you?",
        "timeApproximation": "~3 minutes",
        "perex": "Internet, applications, social networks... Excellent helpers, or tireless time thieves?",
        "list": [
          "Answer 10 questions to find out how you stand in the digital world.",
          "The result will tell you how to regain your lost balance (if needed)."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologist from uLekára.sk",
          "workplace": "Psychology"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/2EEl0j"
      }
    },
    "sleephealth": {
      "dashboardBox": {
        "title": "Sleep Health Test",
        "text": "Take a test to see how well you’re sleeping.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Are you really sleeping well?",
        "timeApproximation": "~3 minutes",
        "perex": "Find out if you’re recharging your energy while you sleep, or if your body is just running on autopilot.",
        "list": [
          "Answer 10 short questions.",
          "Read your results and discover tips for better rest and more energy during the day."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "PhDr. Sylvie Navarová",
          "specialization": "Psychologist, psychotherapist",
          "workplace": "Psychological Services Centre, Ostrava"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/1AXLV4"
      }
    },
    "drinkfree": {
      "dashboardBox": {
        "title": "Alcohol and you",
        "text": "How’s your drinking? Take our test to find out.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Where do you stand with alcohol?",
        "timeApproximation": "~3 minutes",
        "perex": "Eight questions will give you insight into your relationship with alcohol – and what could change if you take a break.",
        "list": [
          "Choose the answer that describes you best.",
          "Read your results. (Note: This test is not a diagnostic tool.)"
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Barbora Magdolenová",
          "specialization": "Psychiatrist",
          "workplace": "Brno Psychiatric Hospital"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/A7pgGD"
      }
    },
    "intimateHealth": {
      "dashboardBox": {
        "button": "Complete the form",
        "text": "Check your intimate health with 10 questions.",
        "title": "Your intimate health"
      },
      "infoStep": {
        "button": "Complete the form",
        "garant": {
          "name": "MUDr. Petra Polášková",
          "specialization": "Gynecologist",
          "title": "Test sponsor",
          "workplace": "FertilityPort Prague s.r.o."
        },
        "list": [
          "Choose the answer that best describes you for each question.",
          "You’ll immediately see your results along with practical tips."
        ],
        "perex": "Ten questions will give you insight into how you care for your intimate health – what you’re doing well and where a little extra attention could help.",
        "timeApproximation": "~3 minutes",
        "title": "How well do you care for your intimate health?"
      },
      "urls": {
        "b2b": "https://tally.so/r/ZjNbWa"
      }
    },
    "workbalance": {
      "dashboardBox": {
        "text": "10 questions to check your burnout risk.",
        "title": "Work, stress and you"
      },
      "infoStep": {
        "button": "Complete the test",
        "garant": {
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychology",
          "title": "Test sponsor",
          "workplace": "Psychologist from uLékaře.cz"
        },
        "list": [
          "Choose the answer that best describes you for each question.",
          "You’ll immediately see your results along with practical tips."
        ],
        "perex": "This short test will help you see how you’re managing workload, stress, and energy. It’s not a diagnostic tool – just a way to reflect on yourself.",
        "timeApproximation": "~3 minutes",
        "title": "How do you handle work pressure?"
      },
      "urls": {
        "b2b": "https://tally.so/r/MeL1AX"
      }
    },
    "foodstyle": {
      "dashboardBox": {
        "button": "Complete the test",
        "text": "What does your plate say about you?",
        "title": "Your plate check"
      },
      "infoStep": {
        "button": "Complete the test",
        "garant": {
          "name": "Mgr. Lucie Burdová",
          "specialization": "Consulting",
          "title": "Test sponsor",
          "workplace": "Nutritional therapist"
        },
        "list": [
          "Don’t answer how you think you should eat, but how you really eat.",
          "Check your result, including practical tips."
        ],
        "perex": "This quick test reveals whether your diet works as proper fuel or just as a quick fix for hunger.",
        "timeApproximation": "~3 minutes",
        "title": "Are you actually eating well?"
      },
      "urls": {
        "b2b": "https://tally.so/r/vGxbPv"
      }
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Choose subscription",
    "language": {
      "title": "Service settings",
      "text": "Select the language you want to use for the uLékaře.cz Virtual Hospital service.",
      "errorText": "Current language is not supported by the selected partner. Select another language."
    },
    "final": {
      "title": "Sign up completed successfully",
      "text": "Now you can start using uLekára.sk services. Our doctors and nurses are here for your."
    },
    "possiblePartners": {
      "title": "It looks like you're entitled to this service for free",
      "textHrb": "Confirm one from the bellow shown emplyees or partners who pay for the service. Can't you choose? Change the partner.",
      "changePartner": "Change partner"
    },
    "hrbPartner": {
      "title": "Activate free service",
      "textBoth": "To activate free service, please enter the company email or the activation code that you received from {partner}.",
      "textEmail": "To activate free service, please enter the company email",
      "textCode": "To activate free service, please enter the activation code that you received from {partner}.",
      "tabs": [
        "With email",
        "With code"
      ],
      "email": "Company e-mail",
      "code": "Activation code",
      "codeError": "<strong>Unfortunately, this code is invalid.</strong><br>Please check the correctness of the code with your HR department.<br>If the code is correct, we will be happy to help you at",
      "emailError": "Invalid email address. Need help? Contact us.",
      "invalidEmployeeEmail": "This email address is not permitted for the selected employer-partner.",
      "benefitBlocked": "This email address has been used for a different employer/partner, and cannot be used for activation.",
      "clientSupport": "client support",
      "startTitle": "Active free service",
      "formTitle": "Enter company email address or code",
      "startUsing": "Enter company email address or code",
      "formDescription": "Please fill in the following information to check whether you’re entitled to free service.",
      "description": {
        "code": "Activation code",
        "email": "Activation email"
      }
    },
    "emailAuthorization": {
      "title": "Request to activate the free service sent",
      "text": [
        {
          "title": "Didn’t get the email?",
          "list": [
            {},
            {
              "text ": "Delivery may take a while."
            }
          ]
        },
        {
          "title": "Did you provide an incorrect email address?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            },
            "textBefore": "Change it",
            "text": "here"
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Resend email"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Who pays for the service?",
      "text": "Have uLekára.sk services for free! Maybe your employer or one of our partners (insurance companies, credit card companies, etc.) will pay for it.",
      "employees": "Employers",
      "search": "Find your employer by name.",
      "searchSignText": "Start writing the name of the company you work for. We'll find it together.",
      "searchEmpty": {
        "title": "We could not find “{text}” in our list",
        "text": "If you believe that the company should join our list, feel free to {email}.",
        "emailText": "reach out"
      },
      "selfPay": "I pay myself"
    },
    "selfPay": {
      "title": "I pay myself",
      "text": "As a self-payer, you can enjoy:",
      "list": [
        {
          "icon": "shield",
          "text": "Personalized prevention plan "
        },
        {
          "icon": "news",
          "text": "Practical health tips & arcticles"
        },
        {
          "icon": "phone",
          "text": "Handy mobile application"
        }
      ]
    },
    "mastercard": {
      "title": "Verify your Mastercard<sup>®</sup> card",
      "codeInvalidError": "The number entered is not valid. Make sure you enter 6 numbers from your Premium or Business Mastercard<sup>®</sup> card.",
      "label": "First 6 digits of the card"
    },
    "external": {
      "titleSlot": "Free service verification failed.",
      "vozpText": "As a VoZP client, log in to the VoZP Client Portal and click on the uLékaře.cz logo. After you log in for the first time, you will have access to all our services.",
      "ozpText": "For OZP clients, the uLékaře.cz Virtual Hospital service is available 24/7 via the VITAKARTA. Please log in to your VITAKARTA account.",
      "drmaxText": "As a Dr. Max client, log in the the Benefits Card and click on the uLékaře.cz logo.",
      "mcText": "We need to verify the first six digits of your Mastercard<sup>®</sup> Premium card. No payment is involved, and after entering it successfully, you will be able to use uLékaře.cz Virtual Hospital services for free.",
      "fairsuranceText": "To activate the free service, please enter the authorization code you obtained from Fairsurance.",
      "sporthelpText": "{title}To activate the free service for members of SportHelp sports insurance, click on the link to the service that you'll find in your digital membership card in the Medical Consultation Service section of uLékaře.cz.",
      "defaultErrorText": "Authorization link cannot be applied as it has already expired. Thank you for understanding."
    },
    "chooseDifferentCompany": "Change partner"
  },
  "profile": {
    "title": "My account",
    "titleMobile": "Settings",
    "subtitle": "Manage your information.",
    "basicData": "Basic information",
    "emailNote": "You cannot change your email address.",
    "phoneNote": "Our nurses will use this number to contact you for additional information or scheduling a doctor's appointment.",
    "security": "Security",
    "currentPassword": "Current password",
    "invalidCurrentPassword": "Invalid current password",
    "currentPasswordUsedInHistory": "The new password cannot be the same as the old one.",
    "newPassword": "New password",
    "additionalInfo": "Additional information",
    "birthDateNote": "Your age will help the doctor give you better information.",
    "address": "Address",
    "addressNote": "We can use your address to find you a suitable doctor.",
    "family": "My family",
    "aboutApp": "About app",
    "applicationLock": "App lock",
    "moreOptions": "Other",
    "healthInsuranceProvider": {
      "title": "Health insurance company",
      "note": "We'll find a doctor who works with your insurer."
    },
    "applicationLanguage": {
      "title": "Application language",
      "message": "This language is used for web"
    },
    "serviceLanguage": {
      "title": "Service language",
      "message": "Answer from doctor will be in this language"
    },
    "changeLanguageNotification": {
      "text": "When saved the web language will be changed to",
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak",
      "uk": "Ukrainian",
      "ru": "Russian"
    },
    "storeMessage": {
      "success": "Changes saved.",
      "error": "Changes not saved. Please check that the information you provided is correct.",
      "passwordError": "Changes have not been saved - original password incorrect."
    },
    "ucb": {
      "title": "Legal documents and information",
      "text": "Please note that UniCredit Bank Czech Republic and Slovakia, a.s. assumes no responsibility for the content and conduct of the service provided to employees. The use of this service by employees is voluntary and the responsibility for the delivery of the service in the form of medical advice rests with the service provider, uLékaře.cz, s.r.o., who is responsible for ensuring that the medical advice is provided exclusively by a person qualified to do so under applicable Czech law. Before using the medical advice service, employees are advised to properly read the {terms_and_conditions} of using the service.",
      "termsAndConditions": "terms and conditions"
    },
    "removeSection": {
      "title": "Account cancellation",
      "text": "Your account will be deactivated. If you change your mind, you can cancel the deactivation by logging into your account. After 30 days, you will not be able to return to your account.",
      "button": "Cancel account"
    },
    "removeDialog": {
      "title": "Are you really sure?",
      "areYouSure": {
        "text": "Your account will be deactivated. If you change your mind, you can cancel the deactivation by logging into your account. After 30 days, you will not be able to return to your account.",
        "yes": "Delete account",
        "no": "Stay healthy",
        "title": "Do you really want to cancel your account?"
      },
      "list": [
        {
          "icon": "chat-empty",
          "text": "You will lose your prevention guide. Taking care of your health will now be more difficult."
        },
        {
          "icon": "surgeon",
          "text": "You will say goodbye to more than 350 doctors and nurses who help you."
        },
        {
          "icon": "person-sad",
          "text": "You will lose valuable answers from doctors and an overview of your health."
        }
      ],
      "footer": "Do you have questions or need help? Our customer care team is here for you at {email} or {phone}.",
      "cancelButton": "Stay healthy",
      "deleteButton": "Cancel account",
      "confirmTitle": "Your account will be cancelled.",
      "confirmText": "If you change your mind, you can restore your account by logging in within the next 30 days using your current login information. <br/>If you have any questions, please contact our customer support at <a href=\"mailto: info@ulekare.cz\">info@ulekare.cz</a> or <a href=\"tel:00420227072720\">+420 227 072 720</a>.",
      "feedback": {
        "title": "Why are you leaving?",
        "checkboxes": {
          "no_or_low_use": "I no longer need the service or I use it little.",
          "disappointed": "The services did not meet my expectations",
          "technical_issues": "Technical issues with the system",
          "price_too_high": "The price is high for me.",
          "better_alternative": "I use another service",
          "other": "Other reason / I prefer not to say"
        },
        "detailsLabel": "Tell us more",
        "confirm": "Delete account",
        "cancel": "Stay healthy"
      }
    },
    "benefits": {
      "consultation_forum": {
        "chip": "Consultations",
        "tooltip": "Send a doctor a question whenever and from wherever. He or she will answer you on-line."
      },
      "booking": {
        "chip": "Appointments"
      },
      "prevention_plan": {
        "chip": "My prevention"
      },
      "insurance_contributions": {
        "chip": "Insurance benefits",
        "tooltip": "Find out what insurer contributions you’re entitled to."
      },
      "health_tests": {
        "chip": "Medical tests",
        "tooltip": "Complete a short test and find out more about your health."
      },
      "video_call_therapist": {
        "chip": "Video call: therapist",
        "tooltip": "Book an on-line session with a therapist."
      },
      "content_explore": {
        "chip": "Discover"
      },
      "helpline_free": {
        "chip": "Toll-free line",
        "tooltip": "We’re here for you on workdays from 8:00 a.m. to 5:00 p.m."
      },
      "video_call_doctor": {
        "chip": "Video call: doctor",
        "tooltip": "Book a video call with a doctor."
      },
      "assistance_line": {
        "chip": "Assistance hotline"
      },
      "blood_tests_review": {
        "chip": "Blood tests + explanation"
      }
    },
    "benefit": {
      "validTo": "Valid to",
      "availableServices": "Available for you",
      "title": "Service admin",
      "subtitle": "Your current free service configuration",
      "card": {
        "authorize": "Active",
        "prolong": "Expires soon",
        "pending": "Waiting for completion of service activation",
        "ended": "Expired",
        "family": "Active (family member)",
        "familyExpired": "Ask your family member about extending the free service"
      },
      "partnerSuggestions": {
        "title": "Change in free service provider",
        "subtitle": "Only one company or partner can cover your free service",
        "nosearch": {
          "title": "Don’t want to search? That’s OK.",
          "subtitle": "Perhaps you can have the service for free thanks to one of our six partners."
        }
      },
      "searchPlaceholder": "Enter company or partner name",
      "selectPartner": "Activate free service",
      "serviceNotActive": "Free service is not active",
      "b2c": {
        "title": "You don’t have a company or partner assigned that would cover the service for you.",
        "subtitle": "Enter the name of a company or partner to get free access to the service. A partner can be your insurance company, card issuer, or similar."
      },
      "authorization": {
        "none": "Other form of activation",
        "email": "Activation with e-mail",
        "codeOnly": "Activation with a code",
        "codeAndEmail": "Activation with code and email",
        "code": {
          "finished": {
            "buttonText": "Finished"
          }
        }
      },
      "prolong": {
        "buttonText": "Extend your free service"
      },
      "authorize": {
        "buttonText": "Activate your free service"
      },
      "goback": "Back",
      "partnerDetected": {
        "title": "It looks like you’re entitled to free service. Is that right?",
        "subtitle": "If yes, activate the free service."
      },
      "family": {
        "buttonText": "Current settings"
      },
      "ended": {
        "buttonText": "Extend free service"
      },
      "info": {
        "ended": "Reactivate free service",
        "authorize": "Free service is active",
        "prolong": "Free service will soon expire",
        "family": "Free service is active thanks to family sharing"
      },
      "manage": {
        "buttonText": "Service settings"
      },
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "multifactor": {
      "label": "Two-factor authentication",
      "off": "Off",
      "offInfo": "Two-factor authentication disabled",
      "sms": "SMS verification",
      "smsInfo": "A verification code will be sent to your phone when signing in.",
      "email": "Email verification",
      "emailInfo": "You’ll receive a verification code by email when you try to sign in."
    },
    "appSecurity": "App security"
  },
  "passwordRenewal": {
    "title": "Update your password.",
    "subtitle": "You need to update your password because your password has expired.",
    "currentPassword": "Current password:",
    "newPassword": "New password:",
    "confirmation": "Confirm your new password",
    "passwordsDontMatch": "Passwords do not match",
    "button": "Change password",
    "thankYouTitle": "Password has been changed",
    "thankYouSubtitle": "Your password has been successfully changed. Thank you for your cooperation!"
  },
  "subscription": {
    "signpost": {
      "title": "How do you want to use the service?",
      "b2cButton": "I want to become a client",
      "b2bButton": "I'm entitled to free service"
    }
  },
  "questions": {
    "answerDisclaimer": "Please note that the answer above is for information only. It involves general advice and information in the area of health, illness, or other health problems. The information provided above cannot be considered an individual diagnosis, treatment plan, or prevention plan, especially given the limited capabilities of on-line communication. Given that information from users cannot be complete and a&nbsp;physical examination is impossible, answers from individual doctors may differ in details depending on their experience and clinical practice. Use of the service is in no way a&nbsp;substitute for a personal examination by a doctor. If you have health problems, we recommend seeking medical or other specialized help depending on their nature. The doctor’s answer may have been translated using an automatic translation tool; it is always then checked thoroughly by a medical professional.",
    "title": "Consultations",
    "subtitle": "Keep track of your questions. Ask our doctors.",
    "noQuestion": {
      "title": "We are still waiting for your first question.",
      "subtitle": "How can we help you?",
      "infoList": [
        {
          "text": "You will quickly find out whether you can deal with a health problem yourself or if you need to seek medical help.",
          "icon": "suitcase"
        },
        {
          "text": "A doctor from our consultation service will advise you as to what sort of examination to undergo or the right specialist to see.",
          "icon": "surgeon-question"
        },
        {
          "text": "Our experts will help you understand the medical report or lab results.",
          "icon": "stop"
        },
        {
          "text": "Don't worry, we can help with your family's health problems too.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "New question",
    "newSolved": "Processing",
    "waitingForAnswer": "Waiting for an answer",
    "history": "Question history",
    "detail": {
      "title": "Question details",
      "sent": "Sent",
      "questionFormTitle": "Health problem description",
      "attachments": "Attachments",
      "helped": "Did the answer help you?"
    },
    "evaluation": {
      "title": "Thank you for your reaction",
      "text": "It will help us improve our services. Would you like to tell us anything else?",
      "label": "Additional comments and suggestions",
      "placeholder": "How can we improve the service?",
      "ok": "Answer helped",
      "nok": "Answer didn't help"
    },
    "thankYou": {
      "title": "Your question has been sent",
      "subtitle": "(The service will be delivered in the {language} language)",
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak",
      "text": "Our generall practitioner is curently reviewing your request. We'll notify you via email as soon as your question is answered."
    },
    "status": {
      "waitingGpAnswer": "Your question is waiting to be answered by a GP.",
      "waitingSpecialistAnswer": "Your question is waiting to be answered by a specialist.",
      "answered": "Your question has been answered.",
      "transferToAppointment": "Your question has been transferred to appointment scheduling. We will contact you.",
      "declined": "Your question has been rejected.",
      "emergency": "Your question has been answered. It seems as a life-threatening condition and we recommend visiting the nearest emergency room."
    },
    "askedQuestions": "Submitted questions"
  },
  "appointments": {
    "title": "My appointments",
    "subtitle": "Keep track of your questions. Ask us to find you a suitable doctor.",
    "statuses": {
      "newDoctor": "We found a doctor.",
      "newZZ": "We've found health care facilities."
    },
    "noAppointments": {
      "title": "You don't have any appointments yet.",
      "subtitle": "And do you know how the service works?",
      "infoList": [
        {
          "text": "We schedule appointments with doctors throughout Slovakia.",
          "icon": "hospital"
        },
        {
          "text": "The next workday one of our nurses will contact you and discuss everything we need to find you a doctor.",
          "icon": "nurse"
        },
        {
          "text": "Don't waste time looking for a doctor, we'll do it for you.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "New appointment",
    "activeAppointments": "Active appointments",
    "visitAppointments": "Don't forget to visit the doctor",
    "evaluateAppointments": "Rate your doctor visit",
    "history": "Appointment history",
    "evaluation": {
      "ok": "I was satisfied",
      "nok": "I wasn't satisfied",
      "noVisit": "Visit didn't happen"
    },
    "detail": {
      "title": "Appointment details",
      "sent": "Sent",
      "date": "Appointment date: ",
      "visitAt": "When to visit: ",
      "facility": "Medical facility: ",
      "address": "Address: ",
      "doctor": "Doctor: ",
      "phone": "Phone number: ",
      "note": "Note: ",
      "dateMandatory": "You must come on this date!",
      "unableToVisitInfo": "If you cannot make the scheduled doctor's appointment, please call {phone} or write us at <a href='mailto:{email}'>{email}</a>",
      "thankYou": "We trust that the doctor we recommended will help you with your health problems. Please let us know how it went. Thank you!",
      "additionalQuestion": "I have an additional question",
      "changeDate": "Change date",
      "cancelAppointment": "Cancel appointment",
      "helped": "How do you rate the order?",
      "noVisit": "Didn't happen"
    },
    "thankYou": {
      "title": "Your appointment request has been sent",
      "subtitle": "(The service will be delivered in the {language} language)",
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak",
      "text": "A nurse will contact you the following workday from the number +420 227 072 720.",
      "others": {
        "text": "For the follow-up communication, please obtain the following information about the person:",
        "items": [
          {
            "icon": "register",
            "text": "national ID number & health insurance"
          },
          {
            "icon": "person-happy",
            "text": "current state of health"
          },
          {
            "icon": "news",
            "text": "medical exam history & requests"
          },
          {
            "icon": "clock",
            "text": "time availability"
          }
        ]
      }
    },
    "status": {
      "waiting": "Your scheduling request is waiting to be processed. Please wait for us to contact you.",
      "lookingForDoctor": "We're working on finding a suitable doctor.",
      "orderedForTime": "Your doctor's appointment is for {datetime}",
      "orderedForOpeningHours": "Your appointment has been scheduled. Visit the doctor during visiting hours.",
      "sendContact": "The doctor's contact information has been sent.",
      "done": "Your scheduling request has been processed.",
      "cancelled": "Appointment cancelled."
    },
    "previousAppointments": "Order history"
  },
  "prevention": {
    "title": "Start with prevention. For your health.",
    "subtitle": "Fill in a bit of information and get customized prevention. We'll help you avoid health problems and illnesses.",
    "birthDateNote": "Age is just a number. We need to know it to provide you with the right care.",
    "healthInsuranceProviderNote": "For making appointments with doctors cooperating with the insurer.",
    "personalization": {
      "banner": {
        "title": "Prevention that fits you",
        "subtitle": "Give us a&nbsp;few details about yourself, and get a&nbsp;prevention plan tailored just for you.",
        "button": "Get tailored prevention"
      },
      "title": "Check-up personalization by age",
      "text": "Turning this off will also show preventive check-ups that one usually undergoes when older."
    },
    "start": "Start with prevention",
    "thankYou": {
      "title": "And that's it! Thank you for filling everything in.",
      "text": "Taking preventive care of your own heath can help you avoid health problems and illnesses. You will receive regular tips and news via email on how to care for your health."
    },
    "summary": {
      "title": "Prevention",
      "subtitleDesktop": "We'll help you avoid health problems and illnesses.",
      "subtitleMobile": "Prevent health problems.",
      "showAll": "Show all",
      "intervalEnds": "Ending prescribed interval",
      "planned": "Planned",
      "plannedOn": "Planned at {time}",
      "timeline": {
        "title": "Next",
        "tooltip": "See the closest ending intervals of your check-ups and vaccinations. Make an appointment in time."
      },
      "examinations": {
        "title": "Preventive check-ups",
        "tooltip": "We'll give you a clear overview of your check-ups and their dates."
      },
      "vaccinations": {
        "title": "Vaccination",
        "tooltip": "We'll give you a clear overview of your vaccinations and their dates."
      },
      "others": {
        "title": "Other"
      },
      "tallyTests": {
        "title": "Thematic health tests"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Compulsory check-ups",
        "optional": "Voluntary check-ups"
      },
      "vaccinations": {
        "recommended": "Compulsory vaccinations",
        "optional": "Voluntary vaccinations"
      }
    }
  },
  "labTests": {
    "rowTitle": "Your blood tests",
    "detail": {
      "title": "Lab test details",
      "questionFormTitle": "Health problem description",
      "healthFormTitle": "State of health",
      "attachments": "Attachments",
      "helped": "Did the answer help you?"
    },
    "status": {
      "draft": {
        "title": "Have the sample(s) taken at the lab",
        "text": "Your doctor will be sent the results of your tests.",
        "actionText": "Go to Unilabs"
      },
      "new": "We’re waiting for your lab test results.",
      "answered": "Finished! Read your results and explanation."
    }
  },
  "loginBanner": {
    "title": "We're your guide to better health.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "General practitioners and specialists answer questions."
      },
      {
        "icon": "nurse",
        "text": "Nurses help make doctor's appointments"
      },
      {
        "icon": "shield",
        "text": "A secure environment that's fully in your hands."
      }
    ],
    "show": "How does the service work?",
    "hide": "Close"
  },
  "cookiesConsent": {
    "acceptAll": "Accept all",
    "basic": {
      "title": "Our website works like a doctor",
      "perex": "Our website uses cookie files, and thus works like a doctor who asks questions in order to be able to help you in the best possible way. We use them to collect {technical}, {analytical}, and {marketing} information in order to continually improve and hence be better able to help you all. Do you agree?",
      "technical": "technical",
      "analytical": "analytic",
      "marketing": "business",
      "customize": "Settings"
    },
    "settings": {
      "title": "Configuration of cookies",
      "description": "When you visit our website www.ulekare.cz, the site obtains or stores information in your browser, usually in the form of cookies. This can be information about you, your preference,s and the device you are using. This is usually used to improve the site, so it works as you expect. As a rule, information does not identify you as an individual, but overall can help adapt the environment to your needs. We respect your right to privacy, so you can decide not to accept some cookies, according to the options below. But keep in mind that by blocking some cookies, you can affect how the site works and what services are offered to you.",
      "link": "You can find our cookie statement {hereLink}.",
      "items": {
        "technical": {
          "title": "Technical cookies",
          "bodyText": "These are required to make our site work, so they cannot be switched off. They are usually set up in response to actions you have taken, such as requesting services related to security settings, logging in, filling out forms, and so on. You can set your browser to block cookies or send notifications about them. These cookies do not store any identifiable information."
        },
        "functional": {
          "title": "Functional cookies",
          "bodyText": "These cookies allow the site to be more effective and personal. They may be configured by us or the third-party providers whose services we use on the site. If you do not enable these cookies, some or all of these services may not work properly."
        },
        "analytics": {
          "title": "Analytical cookies",
          "bodyText": "These cookies are used to improve how the website works. They allow us to recognize and track the number of visitors and how they use the website. They help us improve the way the website works. These cookies do not collect information that could identify you."
        },
        "marketing": {
          "title": "Marketing cookies",
          "bodyText": "These are used to track website users' preferences for ad targeting, i.e., to display marketing and advertising messages (including on third-party sites) in accordance with these preferences. <strong>Marketing cookies use the tools of external companies. These marketing cookies will only be used with your consent.</strong>"
        }
      },
      "save": "Save settings"
    },
    "youtube": {
      "text": "We need to use functional cookies to show you this video. You can find more information in our {cookiePolicyLink}.",
      "cookiePolicyLinkText": "cookie policy",
      "accept": "Accept"
    }
  },
  "thematic_counselling": {
    "dashboard": {
      "title": "Focused on prevention",
      "hint": {
        "b2b": "How can you prevent cancer? {desktopBreakline}Which preventive check-ups are appropriate? Ask the specialists.",
        "b2c": "How can you prevent cancer? {desktopBreakline}Which preventive check-ups are appropriate? Get free advice."
      },
      "onco-prevention": {
        "title": "Oncological prevention",
        "short": "We want to help you with any concerns about the serious disease. Our doctors will gladly guide you.",
        "long": "Are you afraid that you have a higher risk of cancer in your family?<br>Which preventive check-ups are appropriate?<br>What can be detected by medical tests?<br>Our doctors will gladly guide you.",
        "footer": "⏱  Specialists from this advisory respond within 48 hours",
        "button": "Ask a doctor",
        "profileSectionButton": "Get consultation"
      },
      "final": {
        "title": "Your query has been sent.",
        "text": "It is now being attended to by our specialist, and we'll let you know by email as soon as your questions have been answered.",
        "button": "Finished"
      },
      "doctors": [
        {
          "name": "MUDr. František Rolinek",
          "specializations": [
            "General Practitioner"
          ],
          "institution": "MUDr. František Rolinek - clinic, Brno",
          "image": "TMP/mudr_frantisek_rolinek.jpeg"
        },
        {
          "name": "MUDr. Lenka Rudolfová",
          "specializations": [
            "General Practitioner"
          ],
          "institution": "AGEL Clinic, Prague",
          "image": "TMP/mudr_lenka_rudolfova.jpeg"
        }
      ]
    }
  },
  "TMP": {
    "fb": {
      "error": "We apologize for the inconvenience. We are facing some technical difficulties with FB login right now. We took contact with FB and are putting extra effort to solve the problems as soon as possible. For new registration please use some of the other methods. For login to your account please try again tomorrow."
    }
  },
  "placeholders": {
    "date": {
      "year": "YYYY",
      "month": "MM",
      "date": "DD"
    },
    "time": {
      "hour": "hh",
      "minute": "mm"
    }
  },
  "unavailableClinics": {
    "title": "We are updating the app for you",
    "description": "We are sorry for a brief service outage. We are deploying new app improvements at the moment. We will be back shortly."
  },
  "releaseNotes": {
    "title": "Welcome to your health zone at uLekára.sk",
    "perex": "A long and healthy life is within your reach, all it takes is the first step. With us, prevention becomes an easy, natural part of your day. Ready to start?",
    "content": [
      {
        "icon": "date-question",
        "text": "When did you last see your GP, and when are you due for your next visit? Add your appointment, and we’ll make sure you don’t miss anything."
      },
      {
        "icon": "payment",
        "text": "Did you know you can save on preventive care for every family member? We have an overview of what your health insurance will reimburse."
      },
      {
        "text": "A quick health check with a recommendation at the end. Do you sleep well? How do you care for your body and mind? This short test will help you find out.",
        "icon": "report"
      }
    ],
    "primaryButtonText": "Start with prevention",
    "secondaryButtonText": "Test yourself"
  },
  "healthInsuranceProviderBenefits": {
    "dashboard": {
      "title": "Insurance company contributions",
      "text": "Find out what benefits your insurance company offers"
    },
    "title": "Select your insurance provider",
    "privateInsuranceProviders": "Private providers",
    "publicInsuranceProviders": "Public providers",
    "showDetail": "Show details",
    "hideDetail": "Hide details",
    "buttonText": "Save insurance provider and display",
    "empty": {
      "title": "No contributions",
      "text": "Unfortunately, the selected insurance provider offers no contributions"
    },
    "fullInfo": {
      "base": "For a complete list of bonuses and conditions, see {link}.",
      "linkText": "the insurance provider's website"
    },
    "footer": {
      "updated": "Updated {date}",
      "changeCompanyInSettings": "Change insurance provider in settings",
      "changeCompany": "Change insurance provider"
    }
  },
  "explore": {
    "title": "Discover",
    "searchTitle": "Back to Discover",
    "subtitle": "Read health tips, recommendations, or stories",
    "articles": {
      "title": "Articles",
      "titleDetail": "Article details",
      "shareText": "I'm sending an interesting article from uLékaře.cz",
      "footer": {
        "title": "Did a question occur to you while reading that you'd like to ask a doctor?",
        "textQuestion": "We'll be glad to answer any question regarding your health, the health of a family member, or this article.",
        "textQuestionOrder": "We'll be glad to answer any question regarding your health, the health of a family member, or this article. And if needed, we'll book your appointments with doctors all across the Czech Republic."
      }
    },
    "consultations": {
      "titleDetail": "Question details"
    }
  },
  "invitation": {
    "dashboard": {
      "title": "Family plan",
      "text": "uLekára.sk service for your family. Free of charge.",
      "buttonText": "Share invite"
    },
    "title": "Keep your family healthy",
    "text": "Invite your family members, free of charge. Give them the possibility to have more than 350 doctors and nurses at hand - 24/7.",
    "list": [
      {
        "icon": "link",
        "text": "Copy the invite link"
      },
      {
        "icon": "rodina",
        "text": "Send it to your family members."
      },
      {
        "icon": "confetti",
        "text": "Free service is available upon registration"
      }
    ],
    "shareLink": "Invite link",
    "copyCode": "Copy invite link",
    "codeCopied": "Copied",
    "familyTitle": "Manage your family",
    "remove": "Remove",
    "shareTitle": "uLékaře.cz free of charge.",
    "shareText": "{personName} is sharing the uLékaře.cz family plan with you. Register via the link and get it free of charge.",
    "emptyMemberName": "Family member"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "editReport": "Edit",
    "markAsDone": "Mark as done",
    "notes": "Your notes",
    "notesPlaceholder": "Add your own notes ...",
    "uploadFiles": "Upload files",
    "information": "Information",
    "content": {
      "content1": "What can I expect?",
      "content2": "How should I prepare?",
      "content3": "Is the check-up covered?",
      "content4": "How should I do it?",
      "content5": "When should I do it?",
      "content6": "What if I find something irregular?",
      "content7": "How is it transmitted?",
      "content8": "Can it be prevented?",
      "content9": "What vaccine should I choose?"
    },
    "boxes": {
      "recommended": "Recommended",
      "male": "For men",
      "female": "For women",
      "from": "from",
      "interval": "Interval",
      "showDetail": "Show detail",
      "letsStart": "Let's start",
      "noRecords": "No records"
    },
    "examination": {
      "title": "Check-up detail",
      "add": "Log check-up",
      "listTitle": "My check-ups",
      "newFormPerex": "Log the check-up date. You can also save notes and files (photos, medical reports, etc.).",
      "editFormPerex": "Here you can edit the date, notes, and manage related files.",
      "optional": "Voluntary check-up",
      "recommended": "Compulsory check-up",
      "type": "Check-up",
      "nextBy": "Next check-up by",
      "next": "Next check-up",
      "last": "Last check-up",
      "new": "New check-up",
      "date": "Check-up date",
      "time": "Check-up time",
      "past": "Past",
      "pastMulti": "Past",
      "future": "Upcoming",
      "missedNotification": "The prescribed check-up interval has been exceeded.",
      "emptyNotification": "Here you can log and manage your check-ups.",
      "errorDateEmpty": "Please enter the check-up date.",
      "errorDateBoundsPast": "Please enter the date of already completed check-up.",
      "errorDateBoundsFuture": "The date must be in future.",
      "todayDateCheckboxLabel": "Check-up took place today",
      "errorTimeRequired": "Please enter the time of your checkup",
      "manageReports": "My check-ups",
      "emptyPlaceholder": {
        "title": "Log your first check-up",
        "perex": "Managing your check-ups was never easier"
      }
    },
    "vaccination": {
      "title": "Vaccination detail",
      "add": "Log vaccination",
      "listTitle": "My vaccinations",
      "newFormPerex": "Log the vaccination date. You can also save notes and files (photos, medical reports, etc.).",
      "editFormPerex": "Here you can edit the date, notes, and manage related files.",
      "optional": "Voluntary vaccination",
      "recommended": "Compulsory vaccination",
      "type": "Vaccination",
      "nextBy": "Next vaccination by",
      "next": "Next vaccination",
      "last": "Last vaccination",
      "new": "New vaccination",
      "date": "Vaccination date",
      "time": "Vaccination time",
      "past": "Past",
      "pastMulti": "Past",
      "future": "Upcoming",
      "missedNotification": "The prescribed vaccination interval has been exceeded.",
      "emptyNotification": "Here you can log and manage your vaccinations.",
      "errorDateEmpty": "Please enter the vaccination date.",
      "errorDateBoundsPast": "Please enter the date of already completed vaccination.",
      "errorDateBoundsFuture": "The date must be in the future.",
      "todayDateCheckboxLabel": "Vaccination took place today",
      "errorTimeRequired": "Please enter the time of your vaccination",
      "manageReports": "My vaccinations",
      "emptyPlaceholder": {
        "title": "Log your first vaccination",
        "perex": "Managing your vaccinations was never easier"
      }
    },
    "trash": {
      "title": "Do you really want to delete the record?",
      "text": "You will delete the record, including any notes and attachments.",
      "keep": "Keep record",
      "delete": "Delete"
    }
  },
  "intervals": {
    "months": {
      "single": "month",
      "plural": "months",
      "semi": "months"
    },
    "years": {
      "single": "year",
      "plural": "years",
      "semi": "years"
    }
  },
  "dateInput": {
    "errors": {
      "invalidFormatDate": "Please enter the date in a valid format between {min} and {max}",
      "invalidFormatMonth": "Please enter the month in a valid format between {min} and {max}"
    }
  },
  "timeInput": {
    "errors": {
      "invalidFormat": "Please enter the time in a valid format between 0:00 and 23:59",
      "required": "Please enter the time"
    }
  },
  "feedback": {
    "title": "How do you like uLekára.sk?",
    "text": "Your feedback is our vitamin. Thanks to you, we keep the app in the best shape possible.",
    "label": "Do you have any ideas for improvement?",
    "placeholder": "Feel free to share them here...",
    "thankYou": {
      "title": "Thank you for the feedback",
      "text": "We do our best to make caring for your health easier."
    },
    "menu": "Feedback",
    "panelButton": "Provide feedback"
  },
  "newsletterAgreement": {
    "dashboard": {
      "title": "Healthy news",
      "text": "We'll send you news and discounts via email."
    },
    "title": "We'll send health to your mailbox.",
    "perex": "Your journey to long-term health starts here.",
    "content": [
      {
        "icon": "confetti",
        "text": "Regular wellness tips."
      },
      {
        "icon": "care",
        "text": "Valuable discounts on products that help you stay healthy."
      },
      {
        "icon": "news",
        "text": "Notification of new articles you'll enjoy reading."
      }
    ],
    "footer": {
      "text": "By clicking on the “Subscribe” button you agree to {link}.",
      "linkText": "receive marketing messages"
    }
  },
  "bloodReport": {
    "infoStep": {
      "title": "Your health with explanations",
      "perex": "Put your health under the microscope. Blood tests and detailed comments by a doctor will help you understand your body.",
      "list": [
        {
          "icon": "register",
          "text": "Describe your current health so recommendations by doctors fit like a glove."
        },
        {
          "icon": "calendar/date-31",
          "text": "We’ll recommend you a suitable test. Pick the time and place that suits you best to provide samples."
        },
        {
          "icon": "doctor",
          "text": "The results will arrive from the lab. Our doctor will explain them in plain language."
        }
      ],
      "legal": [
        "The Lab Test Interpretation service is a medical service provided remotely {link} , only in the field of internal medicine.",
        "Interpretation of lab results is a health service that is not covered by public health insurance.",
        "We process your personal data in accordance with {link}."
      ],
      "legalLinkTexts": [
        "by an independent health services provider",
        {},
        "the Principles of Personal Data Protection"
      ],
      "serviceText": "\nWe will arrange the service for you through the following health service providers:<br/>\n<br>\ntaking blood samples and providing lab results:<br/>\nUnilabs Diagnostics k.s.<br/>\nwith registered office at Evropská 2589/33b, Dejvice, 160&nbsp;00&nbsp;Prague&nbsp;6<br/>\nID: 604&nbsp;70&nbsp;488<br/>\nregistered with the Municipal Court in Prague, File&nbsp;No&nbsp;A&nbsp;76193<br/>\n<br>\ninterpretation of lab results:<br/>\nuLékaře.cz Health Care, s.r.o.<br/>\nwith registered office at Českomoravská 2408/1a, Libeň, 190&nbsp;00&nbsp;Prague&nbsp;9<br/>\nID: 096&nbsp;64&nbsp;777<br/>\nregistered with the Municipal Court in Prague, File No&nbsp;C&nbsp;339989\n      ",
      "agreements": {
        "termsAndConditions": {
          "text": "I agree with  {link} from health services provider uLékaře.cz Health Care, s.r.o.",
          "linkText": "the Terms and Conditions of the Lab Test Interpretation service "
        }
      }
    },
    "finalStep": {
      "title": "What’s next?",
      "text": "Thank you for the information. It will help doctors correctly evaluate the results of your tests. Now we’ll hand you over to Unilabs – our partner laboratory.",
      "button": "Go to Unilabs",
      "list": [
        {
          "title": "Step 1",
          "text": "Select a lab test"
        },
        {
          "title": "Step 2",
          "text": "Reserve a location, date, and time, come and provide a sample"
        },
        {
          "title": "Step 3",
          "text": "We’ll deliver your results, explained by a doctor"
        }
      ]
    }
  },
  "addressInput": {
    "country": "State",
    "postcode": "Postcode",
    "street": "Street and house number"
  },
  "videocall": {
    "chooseDate": "Select a date",
    "confirmReservation": "Confirm reservation",
    "reservationProgressing": "Confirmation in progress",
    "dayOfWeek": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "month": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "thankYou": {
      "info": "We have sent you all the necessary information by email.",
      "success": "Video call successfully scheduled 🎉",
      "close": "Close"
    }
  },
  "videoTherapy": {
    "infoStep": {
      "perex": "Mgr. Věra Kudličková Dušková will discuss work, relationship or psychological problems with you. A 50-minute private online session awaits you.",
      "title": "Feeling down?",
      "list": {
        "third": "Confirmed? Check your email for a link you’ll then use to start \nthe video call with a therapist.",
        "second": "Pick the date and time you’d like to meet the therapist on-line.",
        "first": "First, check your personal and contact details."
      },
      "legal": [
        "The service will be provided by a non-medical services provider:",
        "uLékaře.cz,\nwith registered office: Českomoravská 1a, 190 00 Prague 9, ID: 05341051,\nregistered with the Municipal Court in Prague, File No C 339989",
        "The Video Call With a Therapist service is paid for by your employer.",
        "The Video call With a Therapist service is a non-medical service provided remotely as a video call."
      ],
      "therapist": {
        "image": "mgr_vera_kudlickova_duskova.png",
        "name": "Mgr. Věra Kudličková Dušková",
        "specialization": "Psychologist from uLékaře.cz",
        "workplace": "Psychology"
      }
    },
    "formStep": {
      "legal": {
        "termsConditions": {
          "text": "I agree with {legalText} Video call With a Therapist provided by the uLékaře.cz service"
        }
      }
    },
    "pilot": "Video call with a therapist"
  },
  " profile": {
    "benefits": {
      "content_explore": {
        "chip": "Discover"
      }
    }
  },
  "profil": {
    "benefit": {
      "card": {
        "family": "Active (family member)"
      }
    }
  },
  "homepage": {
    "header": {
      "nav": {
        "login": "Log in",
        "link": [
          "What we do",
          "Why uLekára.sk",
          "Reference",
          "Our service"
        ]
      }
    },
    "footer": {
      "value": [
        "A human touch.",
        "Enthusiasm.",
        "Expertise.",
        "Innovation."
      ],
      "about": "We create the healthiest work environments and provide top-notch data-driven health care. \n     We systematically help companies maintain employee health over the long term."
    }
  },
  "secondFactor": {
    "subtitleEmail": "Two-factor authentication via email",
    "label": "Enter the code you received to verify your sign-in.",
    "rememberDevice": "Don’t require on this device",
    "sendAgain": "Resend code",
    "verify": "Verify code",
    "error": {
      "input": "Enter the code.",
      "invalidCode": "Invalid code"
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "title": "Basic information",
        "whoisAsking": {
          "self": {
            "label": "Myself"
          },
          "other": {
            "label": "Someone else"
          },
          "label": "Who am I asking about?"
        },
        "firstName": {
          "self": {
            "label": "First name",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "lastName": {
          "self": {
            "label": "Surname",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's last name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the surgery."
          },
          "other": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the surgery."
          }
        },
        "birthDate": {
          "self": {
            "label": "Date of birth"
          },
          "other": {
            "label": "Other person's date of birth"
          }
        },
        "gender": {
          "self": {
            "label": "Sex",
            "help": "Select gender"
          },
          "other": {
            "label": "Sex",
            "help": "Select gender",
            "placeholder": "Select gender"
          }
        },
        "phone": {
          "self": {
            "label": "Telephone number",
            "help": "If necessary, a nurse will call you"
          },
          "other": {
            "label": "This person's phone number",
            "help": "If necessary, a nurse will call you."
          }
        },
        "address": {
          "self": {
            "label": "Address",
            "help": "Your address will help us find you a suitable doctor"
          },
          "other": {
            "label": "Address",
            "help": "Your address will help us find you a suitable doctor"
          }
        }
      },
      "questionBasic": {
        "title": "Describe the health problem",
        "questionWhat": {
          "label": "Describe the problem and all its symptoms. The more detailed the description, the more accurate the doctor's answer."
        },
        "questionHowWhen": {
          "label": "How did the problem start and when (date)? Is it recurring? How is it changing over time?"
        },
        "questionPastExamination": {
          "label": "Were you examined by a doctor and what was the result? Was treatment provided (including at home)? Describe it, and whether it helped."
        },
        "healthIssueQuestion": {
          "label": "Ask the doctor a question regarding the described health problem."
        },
        "questionSolutionCountry": {
          "label": "What country would you like help in?"
        },
        "attachments": {
          "label": "Attach photos, medical reports, and the results of any examinations.",
          "help": "Maximum file size is 20 MB, and the maximum total size of all files is 100 MB. You can upload .jpg, .png, pdf, MP3, .avi, or mp4 files."
        }
      },
      "questionAdditional": {
        "title": "Additional information for the doctor",
        "questionAnotherSickness": {
          "self": {
            "label": "Are you being treated for a chronic/other illness?"
          },
          "other": {
            "label": "Is he/she being treated for a chronic/other illness?"
          }
        },
        "questionAnotherSicknessDetails": {
          "self": {
            "label": "Please write what illness you are being treated for."
          },
          "other": {
            "label": "Please state which condition they are being treated for."
          }
        },
        "questionMedications": {
          "self": {
            "label": "Do you regularly take any medications or medicinal products (including birth control)?"
          },
          "other": {
            "label": "Does he/she regularly take any medications or medicinal products (including birth control)?"
          }
        },
        "questionMedicationsDetails": {
          "self": {
            "label": "Provide the names and dosages of medications and/or medicinal products (including birth control) you use."
          },
          "other": {
            "label": "Provide the names and dosages of the medications and/or medicinal products (including birth control) they use."
          }
        },
        "questionAllergies": {
          "self": {
            "label": "Do you have any allergies (especially to medications or medicinal products)?"
          },
          "other": {
            "label": "Does he/she have any allergies (especially to medications or medicinal products)?"
          }
        },
        "questionAllergiesDetails": {
          "self": {
            "label": "Tell us what you're allergic to and the symptoms."
          },
          "other": {
            "label": "Please state what they are allergic to and how it manifests."
          }
        },
        "questionLifestyle": {
          "self": {
            "label": "Specify other factors affecting your health such as smoking, alcohol intake, obesity, unhealthy lifestyle, an arduous profession, stress, etc."
          },
          "other": {
            "label": "Specify the factors that may affect this person's health, such as smoking, alcohol consumption, being overweight, an unhealthy lifestyle, a physically demanding job, stress, etc."
          }
        },
        "questionContact": {
          "label": "If the doctor recommends a face-to-face visit, would you like a nurse to contact you to offer to help with the appointment?",
          "yes": "Yes, I would like to be contacted by a nurse.",
          "no": "No, I do not want the nurse to call."
        }
      }
    },
    "Order": {
      "patient": {
        "title": "Basic information",
        "whoisAsking": {
          "label": "Appointment for",
          "self": {
            "label": "For me"
          },
          "other": {
            "label": "For another person"
          }
        },
        "firstName": {
          "self": {
            "label": "Name",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "lastName": {
          "self": {
            "label": "Surname",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's last name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the doctor's office."
          },
          "other": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the doctor's office."
          }
        },
        "birthDate": {
          "self": {
            "label": "Date of birth"
          },
          "other": {
            "label": "Other person's date of birth"
          }
        },
        "gender": {
          "self": {
            "label": "Sex",
            "help": "Select gender"
          },
          "other": {
            "label": "Sex",
            "help": "Select gender"
          }
        },
        "phone": {
          "self": {
            "label": "Telephone number",
            "help": "If necessary, a nurse will call you."
          },
          "other": {
            "label": "Telephone number",
            "help": "If necessary, a nurse will call you."
          }
        },
        "address": {
          "self": {
            "label": "Address",
            "help": "Your address will help us find you a suitable doctor"
          },
          "other": {
            "label": "Other person's adress",
            "help": "Your address will help us find you a suitable doctor."
          }
        },
        "orderHealthInsurance": {
          "self": {
            "label": "Health insurance company",
            "help": "We're looking for a doctor who works with the insurer."
          },
          "other": {
            "label": "Health insurance company",
            "help": "We're looking for a doctor who works with the insurer."
          }
        }
      },
      "orderBasic": {
        "title": "Health Guide",
        "orderWhat": {
          "label": "What health problem will the appointment concern?",
          "placeholder": "E.g. find a new doctor, make an appointment with an existing one, advise where to go..."
        },
        "orderSpecialist": {
          "label": "What type of doctor or specialist are you looking for?"
        },
        "attachments": {
          "label": "Attach a request form or medical report, if you have one.",
          "help": "Maximum file size is 20 MB, and the maximum total size of all files is 100 MB. You can upload .jpg, .png, pdf, MP3, .avi, or mp4 files."
        },
        "orderLocality": {
          "label": "Where would you like to find a doctor?"
        },
        "orderTimeAvailability": {
          "label": "When would you like to make the appointment for?"
        },
        "orderContact": {
          "label": "How do you want to help with your appointment?",
          "yes": "I prefer to take care of the whole ordering process.",
          "no": "I prefer sending contacts."
        }
      }
    },
    "goPrev": "Previous",
    "goNext": "Next",
    "submit": "Send"
  },
  "orderForm": {
    "thankYou": {
      "title": "The order has been submitted.",
      "perex": "Thank you for your order. You will be notified once it has been processed."
    }
  },
  "common": {
    "ok": "Continue"
  },
  "medicalProcedures": {
    "prevention": [
      {
        "id": "1f4a68b9-205e-48ed-8382-e792dfa29341",
        "icon": "doctor",
        "title": "General practitioner",
        "perex": "A preventive check-up performed by a GP is basically the most important part of healthcare. The specifics of a preventive check-up depend on your age, illnesses, and risk factors.",
        "expectation": "The doctor will check your eyesight, hearing, and skin, your vaccination, your blood pressure, your heart, lungs, thyroid gland, abdomen, and the condition of the veins in your legs. He or she will analyze a sample of your morning urine with a test strip. Mainly in the case of men, he or she will perform a rectal exam. \nAt the age of 18, 30, and 40, and then every two years thereafter, a blood sample is also taken to check fats, sugars, kidney function, the heart and circulatory system. \nStarting at age 40 your doctor will perform an ECG every four years. \nFrom age 50 onward, a fecal occult blood test (FOBT) is performed to check stool samples for hidden (occult) blood. \nYour doctor will give you request forms for screenings and other necessary examinations.",
        "preparation": "Prior to having a blood sample you need to avoid eating after midnight of the previous day, and in the morning drink only pure water. A morning urine sample can be taken at home in mid-urination using a sterile container. It is advisable to make an appointment in advance so the doctor can issue requests for blood samples and other examinations. You should allow about 30 minutes for the check-up.",
        "isItPaid": "Preventive check-ups performed by GPs are covered by public health insurance. Check-ups are performed once every two years."
      },
      {
        "id": "891f7c68-bae0-4040-9907-333177a0ac1a",
        "icon": "tooth",
        "title": "Dentist",
        "perex": "Preventive dental check-ups are important to keep your teeth healthy. Avoid complications that often initially have no symptoms.",
        "expectation": "The dentist will check the condition of your teeth, mucous membranes, gums, and peridontium. He or she will assess your dental hygiene, if needed will remove dental tartar or recommend professional dental hygiene. Intraoral (bite-down) X-rays are used to detect cavities and other problems, as well as an extra-oral (panoramic) x-ray once every two years.",
        "preparation": "Before your visit, brush your teeth thoroughly, including between the teeth. Allow about 15–30 minutes for the check-up.",
        "isItPaid": "Preventive dental check-ups are covered by public health insurance. You are entitled to one check-up a year."
      },
      {
        "id": "0f1bf426-6f77-40d4-933b-f5a1ee275be8",
        "icon": "female-reproductive-system",
        "title": "Gynaecology",
        "perex": "An examination during which a doctor checks a woman's sexual organs, the last date of menstruation, and performs a cytology test.",
        "expectation": "During the examination, your personal and family medical history is checked, and the doctor usually wants to know the most recent date of menstruation. The doctor checks your sexual organs visually, manually, as well as using ultrasound. A preventive check-up includes a cytology test involving a cervical swab, as well as a breast examination and possible instructions regarding self-examination.",
        "preparation": "Perform intimate hygiene, ideally right before visiting the doctor.\nYou should allow about 15-30 minutes for the check-up.",
        "isItPaid": "Preventive check-ups performed by gynaecologists are covered by public health insurance."
      },
      {
        "id": "362e63be-2a2b-4e69-ba01-a2eb5397eb79",
        "icon": "breasts",
        "title": "Breast exam",
        "perex": "An examination of the breasts and armpits used for the timely detection of tumours.",
        "expectation": "An examination using a mammograph is safe and effective It allows high-quality X-rays to be taken with minimal radiation dosage. The exam takes place while standing upright, with the breasts compressed by a device for optimum tissue imaging. The lab tech who performs the mammograms will explain everything to you. The doctor will check and assess the images. For younger women or if additional examination is needed, an ultrasound examination of the breasts and armpits can also be performed.\nAn ultrasound examination is entirely safe and painless, and provides immediate results. It is performed lying down, and is entirely painless and safe. The doctor passes the ultrasound probe over the breasts and sees everything on a screen.",
        "preparation": "No preparation is necessary, but avoiding the use of skin creams and solid deodorants/antiperspirants is recommended. The examination takes about 20 minutes.",
        "isItPaid": "Ultrasound exams are recommended for women up to the age of 40. They are covered by public health insurance, you are eligible for an exam once every 2 year at your gynaecologist.\nAbove the age of 40, mammograms once every two years are covered by insurance."
      },
      {
        "id": "f129ba70-51b5-4820-bc79-6a89072d1ae4",
        "icon": "rectum",
        "title": "Colonoscopy",
        "perex": "This involves an exam of the lower intestine and anus using an endoscopic device that can also take samples from mucous membranes.",
        "expectation": "A colonoscopy is simultaneously a preventive and treatment method used for the timely detection of changes in the intestinal mucous membrane, taking tissue samples for more thorough examination, as well as the removal of certain formations. It is performed using an endoscope inserted through the anus into the colon. The exam takes place in private in order to preserve patient dignity. The examination can be uncomfortable or slightly painful for some, which is why tranquilizers are usually administered prior to the examination, and it can also be performed under general anaesthesia. After the examination, the patient remains at the medical facility for a while.",
        "preparation": "A special diet is recommended for the week prior to the exam, with only porridge-like foods for three days prior to the examination,during the day prior to the colonoscopy only fluids and a laxative solution that will help rid the intestine of any remaining food and feces. This examination must be requested by your GP. It is necessary to do a blood test, including coagulative parameters, and patients taking blood thinners must discuss this fact with their attending doctor and adjust their therapy. The examination takes about 20-30 minutes.",
        "isItPaid": "From age 50 onward it is covered by public health insurance, and you are entitled to an exam once every 10 years if the first colonoscopy is negative. Requests are issued by GPs, and in the case of women also by gynaecologists."
      },
      {
        "id": "1b8fefd5-9ca2-4d5e-afd4-9dbe46c456d4",
        "icon": "eye",
        "title": "Eye exam",
        "perex": "During a preventive eye exam, the ophthalmologist focuses mainly on detection of serious defects that don't hurt an that you aren't aware of.",
        "expectation": "The entire eye is checked, including the surrounding structures such as the conjunctiva and eyelids. The doctor will check your visual acuity to determine whether you need glasses, will measure your intra-ocular pressure, and check the retina. Special attention needs to be paid to patients with high blood pressure and diabetes and those who have a family history of illnesses such as cataracts and glaucoma. Additional devices can be used to measure ocular refractive defects in greater detail as well as to detect other illnesses. The examination is painless and relatively undemanding.",
        "preparation": "No preparation is needed. The examination takes about 30 minutes.",
        "isItPaid": "A preventive eye check-up is covered by public health insurance at any age."
      },
      {
        "id": "467fff1e-a3fe-4403-ba24-670816ec556c",
        "icon": "testicles",
        "title": "Testicular self-examination",
        "perex": "Testicular cancer is most frequent in men aged 15-35 and tumours occur and grow very quickly. It can be treated, but timely detection is key, which is why self-examinations shouldn't be forgotten, especially at this age.",
        "how": "The best time for examining testicles is after a warm shower, when the skin of the scrotum is relaxed. Inspect your testicles, visually and with your fingers. Check for changes in size, shape, and for any changes on the skin or lumps. Palpate each testicle separately with both hands. The testicles include the epididymides, which can fool some people during a self-exam. They should be symmetrical on both sides.",
        "when": "You should perform a self-examination at least once a month, especially between the ages of 15-35. You can set aside a specific day of the month for your self-exam.",
        "findConcerningQuestion": "If you detect any changes in size or colour, find a lump or feel pain, or in the case of any other changes, see a urologist or your GP."
      },
      {
        "id": "df6a924b-8b1f-44be-a564-c055c11b8a27",
        "icon": "breasts-self-care",
        "title": "Breast self-examination",
        "perex": "A breast self-examination is one of the simplest ways to ensure timely detection of a possible carcinoma. It's easy and will only take a few minutes.",
        "how": "During the examination, stand in front of a mirror. For women with large breasts, lying down makes examination easier. Check for differences from the front, from the side, and bending over. Then raise the arm on the side of the examined breast and examine it with the opposite hand - the left hand examines the right breast and vice-versa. Check for changes in breast size and shape, inspect the nipples and squeeze them lightly. Check for any discharge. Palpate your breasts starting at the top and working your way down, then from the sternum to the sides, with circular motion and diagonally from the nipple to all sides. Don't forget the area under the collarbone and the armpits.",
        "when": "Perform the examination after the end of the menstrual cycle, on day five to ten of the cycle. If you don't menstruate, choose a day of the month of your self-examination.",
        "findConcerningQuestion": "In the case of any doubt, however small, visit your gynaecologist or GP."
      },
      {
        "id": "c109b192-3a5b-4bc3-9125-ddddcea8a822",
        "icon": "prostate",
        "title": "Prostate examination",
        "perex": "An examination of the male sexual organs performed by a urologist. He will also check the prostate, blood (PSA), urine, possibly semen and testosterone levels.",
        "expectation": "The examination is performed to check male sexual organs. It is performed visually and by tapping the bladder and the back. The doctor checks the prostate via the anus. A test is also performed of the blood (for the PSA tumour marker) and of the urine, possibly also semen and testosterone levels. A urological exam can also include an ultrasound examination. The examination may be slightly unpleasant, but is not painful.",
        "preparation": "Perform intimate hygiene, ideally right before visiting the doctor.\nYou should allow about 20 minutes for the examination.",
        "isItPaid": "A preventive examination of the prostate is covered by public health insurance. You are eligible for an exam every 3 years from age 50 onward. The price varies, ask your urologist. Starting at age 50, it is good to undergo this examination once a year, but even earlier is recommended, starting at age 40."
      },
      {
        "id": "ec177bfa-7bbf-40f2-a68c-22ab20737315",
        "icon": "dermatology",
        "title": "Examination of moles",
        "perex": "An examination performed by a dermatologist, who will check moles visually, possible using a dermatoscope. Upon suspicion of a positive finding, the doctor sends a tissue sample for a (microscope) histology test.",
        "expectation": "The dermatologist checks all of your skin, especially moles. If something seems suspicious, he or she will examine the mole using a special optical device called a dermatoscope. This device works like a magnifying glass and enlarges the moles many times over. It can be connected to a computer to compare past images. If a mole is suspected of being cancerous, the doctor can excise it and send it for a microscopic histology test. The results are usually discussed during the next visit, or over the phone if needed. Sometimes moles are also removed for aesthetic reasons or because they're causing irritation, for example under a belt, bra strap, and so on.",
        "preparation": "No preparation is needed. The examination takes about 20 minutes, longer in the case of excision.",
        "isItPaid": "A preventive examination of moles isn't covered by public health insurance, but insurance companies may contribute. An annual preventive examination is recommended."
      },
      {
        "id": "f268c41e-244e-42f6-a079-5d44d189b8bf",
        "icon": "brush",
        "title": "Dental hygiene",
        "perex": "Dental hygiene is the prevention of cavities, periodontitis (inflammation of the gums), and oral infection. It primarily involves the removal of dental tartar, plaque, and pigment.",
        "expectation": "The dental hygienist will check your teeth, especially the peridontium (in which the teeth are embedded). They will remove plaque and pigment from the teeth and under the gums down to 3 mm. They will remove tartar, clean the teeth professionally, polish them, and if needed perform fluoridation.\nPart of a visit to a hygienist is checking, instruction, and demonstration of proper cleaning and use of dental aids. This reduces the incidence of diseases of the oral cavity, teeth, and gums, including periodontitis.",
        "preparation": "Prior to your visit you should brush your teeth, including your interdental gaps. We recommend taking along any dental aids you use. \nYou should allow about 30-60 minutes for the check-up.",
        "isItPaid": "Dental hygiene isn't covered by public health insurance, but insurance companies may contribute. Ask your hygienist. A visit is recommended twice a year."
      }
    ],
    "vaccination": [
      {
        "id": "77812777-eb63-42d8-a61e-1006038a4bdc",
        "icon": "vaccine",
        "name": "Tetanus",
        "perex": "Tetanus, also called lockjaw, is a serious illness that is a frequent cause of death, primarily in developing countries. This illness is caused by Clostridium tetani bacteria, which are routinely present in human and animal intestines, especially those of farm animals.\nThanks to high vaccination rates, it has largely disappeared.",
        "prevention": "Vaccination is effective prevention against tetanus. The first dose is given to children as part of a combined vaccine. In adulthood, boosters are given every 10-15 years up to the age of 59, after that every 10 years is recommended.",
        "vaccineChoice": "We recommend the Vacteta vaccine, which is funded by public health insurance."
      },
      {
        "id": "39ee715f-b4d8-4f76-9cc8-14ff327c0d07",
        "icon": "vaccine",
        "name": "Whooping cough",
        "perex": "Whooping cough is a highly infectious disease caused by Bordetella pertussis bacteria. It is also sometimes called \"100-day-cough\" or \"pertussis\". It occurs throughout the world. Unvaccinated children up to the age of six are most at risk, but infection is possible at any age.",
        "prevention": "Vaccination is the most effective prevention against whooping cough. Vaccination for this disease is part of mandatory vaccines for children. It is usually given as part of a combined vaccine, and a booster is recommended at least once during one's lifetime.",
        "vaccineChoice": "We recommend the Adacel vaccine, which is funded for children by public health insurance. When not covered, some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "1c9d2dc9-bdd6-488d-968e-4626579aeb45",
        "icon": "vaccine",
        "name": "Flu",
        "perex": "The flu is a contagious viral disease that afflicts a large part of the population every year. Old people, children, and the chronically ill are at greatest risk. Symptoms include extreme fatigue, fever, cough, muscle and joint pain, and headaches. The flu occurs primarily during the winter season, and lasts roughly 1-2 weeks.",
        "prevention": "Effective prevention includes boosting the immune system by eating a balanced diet, adequate vitamin intake and drinking enough fluids, getting a reasonable amount of exercise, sleeping well, hardening the organism, and proper hygiene. Getting an annual flu vaccine also helps.",
        "vaccineChoice": "We recommend the Vaxigrip Tetra vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "c9827908-b47c-4fe1-b4ad-fdaa154a74de",
        "icon": "vaccine",
        "name": "Tick-borne encephalitis",
        "perex": "Tick-borne encephalitis is a viral disease that afflicts the human nervous system. The Czech Republic is considered a high-risk country due to high infection rates.",
        "prevention": "Appropriate prevention includes wearing suitable clothing outdoors, using repellents, and upon returning home examining the body for any ticks that may have attached themselves.\nVaccination is effective prevention against tick-borne encephalitis. The ideal time for vaccination is in the winter, prior to the arrival of spring. The vaccine is given in 3 doses, and a booster is then given after 3 and 5 years.\nHaving had the illness provides immunity, but in the case of younger people it may not last for the rest of one's life, while for older people the assumption is that it does. Antibody levels can be checked by taking a blood sample.",
        "vaccineChoice": "We recommend the FSME-IMMUN vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "d83a0b4c-ff51-40d6-8df4-8521e7c0055f",
        "icon": "vaccine",
        "name": "Pneumococcus",
        "perex": "Pneumococcus is a very serious disease. The Streptococcus pneumoniae bacteria can cause pneumonia, infection of the organism, meningitis, or inner ear infections in children.",
        "prevention": "Vaccination is effective prevention against pneumococcus. Up to the age of 59 one dose is given, another dose is given between the ages 60-64, and after the age of 65 two doses are given.\nAdditional recommendations include boosting one's immune system, leading a healthy lifestyle, and avoiding large groups of people, especially during times of greater incidence of respiratory disease.",
        "vaccineChoice": "We recommend the Prevenar 13 vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "645eddeb-539d-4374-a300-234cd724bb94",
        "icon": "vaccine",
        "name": "Meningococcus B",
        "perex": "Meningococcal disease can cause meningitis, sepsis, high fever, and even death. The Czech Republic has low infection rates, but the death rate is high. Children up to the age of 5 and young people up to the age of 25 are primarily at risk. There are 13 meningococcal disease serotypes.",
        "prevention": "Vaccination is effective prevention against meningococcus. The vaccine is given in two doses at least one month apart, with boosters depending on the vaccine type.\nAdditional recommendations include boosting one's immune system, leading a healthy lifestyle, getting enough sleep and rest, eliminating stress, quitting smoking, and so on.",
        "vaccineChoice": "We recommend the Bexsero vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "7a1affc9-805a-4935-9f52-6dc627bbf4c5",
        "icon": "vaccine",
        "name": "Meningococcus A, C, Y, W-135",
        "perex": "Meningococcal disease can cause meningitis, sepsis, high fever, and even death. The Czech Republic has low infection rates, but the death rate is high. Children up to the age of 5 and young people up to the age of 25 are primarily at risk. There are 13 meningococcal disease serotypes.",
        "prevention": "Vaccination is effective prevention against meningococcus. The vaccine is given in one dose.\nAdditional recommendations include boosting one's immune system, leading a healthy lifestyle, getting enough sleep and rest, eliminating stress, quitting smoking, and so on.",
        "vaccineChoice": "We recommend the Menveo or Nimenrix vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "3b6bf48f-9cb6-4d9e-b2be-6b72b103d648",
        "icon": "vaccine",
        "name": "Hepatitis A",
        "perex": "Hepatitis A is an acute infectious disease of the liver caused by a virus, and is also called the \"dirty hands disease\". It is present throughout the world, especially in countries with low standards of hygiene. In these countries, children are primarily at risk, though are often symptom-free. In the adult population infection has a more prominent nature, but the disease has no permanent consequences.",
        "prevention": "Prevention includes adequate personal hygiene and clean sources of food and water. Vaccination is effective prevention against hepatitis, and is given in two doses spaced a year apart.\nVaccination can take place in combination with vaccination against hepatitis type B, hence A+B together.",
        "vaccineChoice": "We recommend the Havrix 1440 or Vaqta Adult vaccines, which patients pay for themselves.\nFor vaccination against hepatitis A+B, we recommend the Twinrix Adult vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "6a17b093-b6a3-4f38-9b49-2435267d0101",
        "icon": "vaccine",
        "name": "Hepatitis B",
        "perex": "Hepatitis A is a serious infectious disease of the liver caused by a virus. The disease is chronic and can cause cirrhosis of the liver or cancer. The Hepatitis B virus is much more infectious than the HIV virus. Hepatitis B occurs throughout the world. Illness is serious and lasts longer than in the case of Hepatitis A.",
        "prevention": "Vaccination is effective prevention against Hepatitis B. The first dose is given to newborns, with another two doses given 1 and 6 months later. Adults who weren't vaccinated as children can also be vaccinated. Vaccination can take place in combination with vaccination against hepatitis type A, hence A+B together.",
        "vaccineChoice": "We recommend the Engerix B-20 vaccine, which is funded by public health insurance.\nFor vaccination against hepatitis A+B, we recommend the Twinrix Adult vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "c0d340b9-8279-4cfa-a918-ca9f0b40db65",
        "icon": "vaccine",
        "name": "Measles, mumps, rubella",
        "perex": "Measles, mumps, and rubella are very infectious viral diseases.",
        "prevention": "Vaccination is effective prevention. It is applied in childhood as part of compulsory vaccination, and is given as a combined measles, mumps, rubella vaccine. \nA booster shot can be given in adulthood if you work in a high-risk profession, travel, or have been in contact with an infected person.",
        "vaccineChoice": "We recommend MMR or Priorix vaccines, which for children are covered by public health insurance. When not covered by insurance, some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "d206f02a-78a5-4e55-abe9-699de87259f2",
        "icon": "vaccine",
        "name": "Chicken pox",
        "perex": "Chicken pox is a highly infectious disease. It occurs most often during childhood and is usually not severe. However, infection is dangerous for pregnant women. \nThe disease occurs primarily during the winter season, and is the most common infectious disease in the Czech Republic.",
        "prevention": "Vaccination is effective prevention against chicken pox. Vaccination can reduce the likelihood of having shingles during one's lifetime. \nTwo doses are given, at least six weeks apart.",
        "vaccineChoice": "We recommend the Varilix vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "815351d8-b0ea-4c5c-832b-0c6ff3e36320",
        "icon": "vaccine",
        "name": "HPV infection",
        "perex": "HPV infection among the most widespread sexual diseases. More than a hundred HPV types are known, and about 40 of them afflict the sexual organs. Many of those infected are symptom-free, and thus easily continue to spread the virus.",
        "prevention": "Effective prevention of HPV infection includes a healthy lifestyle, eliminating stress, quitting smoking, and avoiding unprotected sex. It also advisable to avoid having multiple sexual partners and long-term use of hormonal contraception. \nVaccination is also an effective form of prevention, for both men and women. An ideal time for vaccination is prior to the commencement of an active sexual life. The vaccine is given in three doses, including to adults who were not vaccinated in childhood.",
        "vaccineChoice": "We recommend the Gardasil or Gardasil 9 vaccine, which patients pay for themselves. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "94a7f086-8aee-418a-a1b4-5f6de0396aa1",
        "icon": "vaccine",
        "name": "COVID-19",
        "perex": "COVID-19 is a highly contagious disease caused by a new type of coronavirus, SARS-CoV-2. This disease is present worldwide. Those infected have various symptoms, and in most cases are mild to moderate, without the need for hospitalization.",
        "prevention": "Effective prevention of COVID-19 includes adequate hand hygiene, avoiding larger groups of people, wearing a respirator, and boosting one's immune system. Vaccination can also help with prevention, and in the case of infection may reduce the severity of the illness. The vaccine is given in one to two doses (depending on the vaccine type), with a third dose given at least five months later. A fourth dose is recommended mainly for those over the age of 60 and at-risk patients, at least four months after the previous dose.",
        "vaccineChoice": "We recommend the Comirnaty, Spikevax, Janssen, Vaxzevria, or Novavax vaccines. Vaccination is covered by public health insurance."
      }
    ]
  },
  "selfReactivated": {
    "title": "Welcome back!",
    "perex": "Your account is active again, and we’re glad to have you with us on your journey to better health. If you need any assistance, our customer support team will be happy to help at <a href=\"mailto:info@ulekara.sk\">info@ulekara.sk\n</a> or <a href=\"tel:00421950105650\">+421 950 105 650</a>.",
    "primaryButtonText": "Continue with uLekára.sk"
  },
  "ePrescription": {
    "title1": "How does ePrescription issuance",
    "perex": "A doctor will assess your health condition as part of your inquiry. Based on that, they may recommend facilitating an ePrescription. Receiving an ePrescription isn’t guaranteed – the doctor will only issue it if it’s safe and appropriate. The uLékaře.cz service doesn’t issue ePrescriptions directly, but we’ll connect you with a healthcare provider who can issue one. Before the ePrescription is actually issued, a nurse will call you to verify the necessary information. Issuing an ePrescription is not available on weekends and public holidays.",
    "disclaimer": {
      "b2b": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed. More {disclaimerLink}",
      "b2c": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed. {disclaimerLink}"
    },
    "disclaimerLink": "More",
    "list": [
      {
        "title": "Reasons you may not receive an ePrescription",
        "subtitle": "For example:",
        "body": [
          "Information about your health condition required to recommend facilitating an ePrescription is missing from your request.",
          "An in-person examination with a doctor is necessary.",
          "The case is more complex or non-standard.",
          "The necessary information could not be verified.",
          "The necessary information could not be verified.",
          "The request concerns another person (ePrescriptions cannot be requested on behalf of a partner, parent, child, or any other person)."
        ]
      },
      {
        "title": "How the process works",
        "body": [
          "Submit a question within your account (you can mention that you are interested in obtaining an ePrescription.",
          "The doctor will review the information you have provided.",
          "If appropriate, the doctor will recommend facilitating an ePrescription.",
          "Before the ePrescription is issued, a nurse will contact you to verify your information.",
          "If it is not possible to recommend facilitating an ePrescription, you will receive guidance on the next steps, such as visiting your GP or a specialist."
        ]
      },
      {
        "title": "What this means for you",
        "body": [
          "Our consultation service offers the possibility of facilitating an ePrescription.",
          "Receiving it isn’t guaranteed – the doctor decides if it’s appropriate to issue.",
          "Issuing an ePrescription is not immediate and requires a short processing time.",
          "We want to help you as best as we can, while always prioritizing correct and safe care."
        ]
      },
      {
        "title": "Can you pick up an ePrescription abroad?",
        "subtitle": [
          "It is not possible to collect medication prescribed via a Slovak ePrescription abroad."
        ],
        "footer": "Medications prescribed via an ePrescription are not covered by health insurance and must be paid for in full."
      }
    ],
    "title2": "work at uLekára.sk",
    "questionDisclaimer": {
      "b2b": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed. More {disclaimerLink}",
      "b2c": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed. {disclaimerLink}"
    },
    "orderDisclaimer": {
      "b2b": "An e-prescription can be issued based on a doctor’s recommendation during the consultation service. This is not possible within the appointment booking service. {disclaimerLink}",
      "b2c": "An e-prescription can be issued based on a doctor’s recommendation during the consultation service. This is not possible within the appointment booking service. {disclaimerLink}"
    },
    "questionDisclaimerLink": "More",
    "orderDisclaimerLink": "Ask a doctor",
    "title": "How does ePrescription issuance work at uLekára.sk"
  },
  "tallyTest": {
    "latestTest": {
      "pill": "NEW TEST"
    }
  },
  "questionPriceInfo": {
    "b2b": "You will pay for asking a question. {price} {currency}, you will receive the doctor's answer within {hours} h.",
    "b2bDiscount": "You will pay for asking a question. {price} {currency} (discount {discountPercent} % from {partnerName}), you will receive the doctor's answer within {hours} h.",
    "b2c": "You will pay for asking a question. {price} {currency}, you will receive the doctor's answer within {hours} h. {termsLink}",
    "b2cLink": "More information"
  }
}